import yudy from "./images/people/yudy.jpeg";
import aldy from "./images/people/aldy.jpeg";
import rafli from "./images/people/rafli.jpeg";
import ali from "./images/people/ali.jpeg";
import hilman from "./images/people/hilman.jpeg";
import linkedin from "./images/icon/linkedin.svg"
import instagram from "./images/icon/instagram.svg"
import facebook from "./images/icon/facebook.svg"

import azra from "./images/people/azra.jpeg";
import ghilman from "./images/people/ghilman.jpeg";
import affandi from "./images/people/affandi.jpg";
import jordan from "./images/people/jordan.png";
import rivaldo from "./images/people/rivaldo.jpg";

import f1_1 from "./images/furniture/1/1.jpg";
import f1_2 from "./images/furniture/1/2.jpg";
import f1_3 from "./images/furniture/1/3.jpg";
import f1_4 from "./images/furniture/1/4.jpg";
import f1_5 from "./images/furniture/1/5.jpg";
import f1_6 from "./images/furniture/1/6.jpg";

import f2_1 from "./images/furniture/2/1.jpg";
import f2_2 from "./images/furniture/2/2.jpg";
import f2_3 from "./images/furniture/2/3.jpg";
import f2_4 from "./images/furniture/2/4.jpg";

import f3_1 from "./images/furniture/3/1.jpg";
import f3_2 from "./images/furniture/3/2.jpg";
import f3_3 from "./images/furniture/3/3.jpg";
import f3_4 from "./images/furniture/3/4.jpg";

import f4_1 from "./images/furniture/4/1.jpg";
import f4_2 from "./images/furniture/4/2.jpg";
import f4_3 from "./images/furniture/4/3.jpg";
import f4_4 from "./images/furniture/4/4.jpg";

import f5_1 from "./images/furniture/5/1.jpg";
import f5_2 from "./images/furniture/5/2.jpg";
import f5_3 from "./images/furniture/5/3.jpg";
import f5_4 from "./images/furniture/5/4.jpg";
import f5_5 from "./images/furniture/5/5.jpg";

import f6_1 from "./images/furniture/6/1.jpg";
import f6_2 from "./images/furniture/6/2.jpg";

import f7_1 from "./images/furniture/7/1.jpg";
import f7_2 from "./images/furniture/7/2.jpg";
import f7_3 from "./images/furniture/7/3.jpg";
import f7_4 from "./images/furniture/7/4.jpg";
import f7_5 from "./images/furniture/7/4.jpg";

import f8_1 from "./images/furniture/8/1.jpg";
import f8_2 from "./images/furniture/8/2.jpg";
import f8_3 from "./images/furniture/8/3.jpg";
import f8_4 from "./images/furniture/8/4.jpg";

import f9_1 from "./images/furniture/9/1.jpg";
import f9_2 from "./images/furniture/9/2.jpg";
import f9_3 from "./images/furniture/9/3.jpg";
import f9_4 from "./images/furniture/9/4.jpg";
import f9_5 from "./images/furniture/9/5.jpg";
import f9_6 from "./images/furniture/9/6.jpg";

import f10_1 from "./images/furniture/10/1.jpg";
import f10_2 from "./images/furniture/10/2.jpg";
import f10_3 from "./images/furniture/10/3.jpg";
import f10_4 from "./images/furniture/10/4.jpg";

import f11_1 from "./images/furniture/11/1.jpg";
import f11_2 from "./images/furniture/11/2.jpg";
import f11_3 from "./images/furniture/11/3.jpg";
import f11_4 from "./images/furniture/11/4.jpg";
import f11_5 from "./images/furniture/11/5.jpg";

import f12_1 from "./images/furniture/12/1.jpg";
import f12_2 from "./images/furniture/12/2.jpg";
import f12_3 from "./images/furniture/12/3.jpg";
import f12_4 from "./images/furniture/12/4.jpg";
import f12_5 from "./images/furniture/12/5.jpg";

import f13_1 from "./images/furniture/13/1.jpg";
import f13_2 from "./images/furniture/13/2.jpg";
import f13_3 from "./images/furniture/13/3.jpg";
import f13_4 from "./images/furniture/13/4.jpg";
import f13_5 from "./images/furniture/13/5.jpg";

import f14_1 from "./images/furniture/14/1.jpg";
import f14_2 from "./images/furniture/14/2.jpg";
import f14_3 from "./images/furniture/14/3.jpg";
import f14_4 from "./images/furniture/14/4.jpg";

import f15_1 from "./images/furniture/15/1.jpg";
import f15_2 from "./images/furniture/15/2.jpg";
import f15_3 from "./images/furniture/15/3.jpg";
import f15_4 from "./images/furniture/15/4.jpg";
import f15_5 from "./images/furniture/15/5.jpg";

import f16_1 from "./images/furniture/16/1.jpg";
import f16_2 from "./images/furniture/16/2.jpg";
import f16_3 from "./images/furniture/16/3.jpg";
import f16_4 from "./images/furniture/16/4.jpg";
import f16_5 from "./images/furniture/16/5.jpg";

import f17_1 from "./images/furniture/17/1.jpg";
import f17_2 from "./images/furniture/17/2.jpg";
import f17_3 from "./images/furniture/17/3.jpg";
import f17_4 from "./images/furniture/17/4.jpg";
import f17_5 from "./images/furniture/17/5.jpg";

import f18_1 from "./images/furniture/18/1.jpg";
import f18_2 from "./images/furniture/18/2.jpg";
import f18_3 from "./images/furniture/18/3.jpg";
import f18_4 from "./images/furniture/18/4.jpg";

import f19_1 from "./images/furniture/19/1.jpg";
import f19_2 from "./images/furniture/19/2.jpg";
import f19_3 from "./images/furniture/19/3.jpg";
import f19_4 from "./images/furniture/19/4.jpg";
import f19_5 from "./images/furniture/19/5.jpg";

import f20_1 from "./images/furniture/20/1.jpg";
import f20_2 from "./images/furniture/20/2.jpg";
import f20_3 from "./images/furniture/20/3.jpg";
import f20_4 from "./images/furniture/20/4.jpg";

import f21_1 from "./images/furniture/21/1.jpg";
import f21_2 from "./images/furniture/21/2.jpg";
import f21_3 from "./images/furniture/21/3.jpg";
import f21_4 from "./images/furniture/21/4.jpg";

import f22_1 from "./images/furniture/22/1.jpg";
import f22_2 from "./images/furniture/22/2.jpg";
import f22_3 from "./images/furniture/22/3.jpg";
import f22_4 from "./images/furniture/22/4.jpg";

import f23_1 from "./images/furniture/23/1.jpg";
import f23_2 from "./images/furniture/23/2.jpg";
import f23_3 from "./images/furniture/23/3.jpg";
import f23_4 from "./images/furniture/23/4.jpg";

import f24_1 from "./images/furniture/24/1.jpg";
import f24_2 from "./images/furniture/24/2.jpg";
import f24_3 from "./images/furniture/24/3.jpg";
import f24_4 from "./images/furniture/24/4.jpg";
import f24_5 from "./images/furniture/24/5.jpg";

import f25_1 from "./images/furniture/25/1.jpg";
import f25_2 from "./images/furniture/25/2.jpg";
import f25_3 from "./images/furniture/25/3.jpg";
import f25_4 from "./images/furniture/25/4.jpg";

import f26_1 from "./images/furniture/26/1.jpg";
import f26_2 from "./images/furniture/26/2.jpg";
import f26_3 from "./images/furniture/26/3.jpg";
import f26_4 from "./images/furniture/26/4.jpg";

import f27_1 from "./images/furniture/27/1.jpg";
import f27_2 from "./images/furniture/27/2.jpg";
import f27_3 from "./images/furniture/27/3.jpg";
import f27_4 from "./images/furniture/27/4.jpg";

import f28_1 from "./images/furniture/28/1.jpg";
import f28_2 from "./images/furniture/28/2.jpg";
import f28_3 from "./images/furniture/28/3.jpg";

import f29_1 from "./images/furniture/29/1.jpg";
import f29_2 from "./images/furniture/29/2.jpg";
import f29_3 from "./images/furniture/29/3.jpg";

import f30_1 from "./images/furniture/30/1.jpg";
import f30_2 from "./images/furniture/30/2.jpg";
import f30_3 from "./images/furniture/30/3.jpg";
import f30_4 from "./images/furniture/30/4.jpg";
import f30_5 from "./images/furniture/30/5.jpg";

import f31_1 from "./images/furniture/31/1.jpg";
import f31_2 from "./images/furniture/31/2.jpg";
import f31_3 from "./images/furniture/31/3.jpg";
import f31_4 from "./images/furniture/31/4.jpg";

import f32_1 from "./images/furniture/32/1.jpg";
import f32_2 from "./images/furniture/32/2.jpg";
import f32_3 from "./images/furniture/32/3.jpg";
import f32_4 from "./images/furniture/32/4.jpg";

import f33_1 from "./images/furniture/33/1.jpg";
import f33_2 from "./images/furniture/33/2.jpg";
import f33_3 from "./images/furniture/33/3.jpg";
import f33_4 from "./images/furniture/33/4.jpg";
import f33_5 from "./images/furniture/33/5.jpg";

import f34_1 from "./images/furniture/34/1.jpg";
import f34_2 from "./images/furniture/34/2.jpg";
import f34_3 from "./images/furniture/34/3.jpg";
import f34_4 from "./images/furniture/34/4.jpg";

import f35_1 from "./images/furniture/35/1.jpg";
import f35_2 from "./images/furniture/35/2.jpg";
import f35_3 from "./images/furniture/35/3.jpg";
import f35_4 from "./images/furniture/35/4.jpg";
import f35_5 from "./images/furniture/35/5.jpg";

import f36_1 from "./images/furniture/36/1.jpg";
import f36_2 from "./images/furniture/36/2.jpg";
import f36_3 from "./images/furniture/36/3.jpg";
import f36_4 from "./images/furniture/36/4.jpg";
import f36_5 from "./images/furniture/36/5.jpg";

import f37_1 from "./images/furniture/37/1.jpg";
import f37_2 from "./images/furniture/37/2.jpg";
import f37_3 from "./images/furniture/37/3.jpg";
import f37_4 from "./images/furniture/37/4.jpg";
import f37_5 from "./images/furniture/37/5.jpg";

import f38_1 from "./images/furniture/38/1.jpg";
import f38_2 from "./images/furniture/38/2.jpg";
import f38_3 from "./images/furniture/38/3.jpg";
import f38_4 from "./images/furniture/38/4.jpg";
import f38_5 from "./images/furniture/38/5.jpg";

import f39_1 from "./images/furniture/39/1.jpg";
import f39_2 from "./images/furniture/39/2.jpg";
import f39_3 from "./images/furniture/39/3.jpg";
import f39_4 from "./images/furniture/39/4.jpg";
import f39_5 from "./images/furniture/39/5.jpg";
import f39_6 from "./images/furniture/39/6.jpg";

import f40_1 from "./images/furniture/40/1.jpg";
import f40_2 from "./images/furniture/40/2.jpg";
import f40_3 from "./images/furniture/40/3.jpg";
import f40_4 from "./images/furniture/40/4.jpg";
import f40_5 from "./images/furniture/40/5.jpg";

import f41_1 from "./images/furniture/41/1.jpg";
import f41_2 from "./images/furniture/41/2.jpg";
import f41_3 from "./images/furniture/41/3.jpg";
import f41_4 from "./images/furniture/41/4.jpg";
import f41_5 from "./images/furniture/41/5.jpg";

import f42_1 from "./images/furniture/42/1.jpg";
import f42_2 from "./images/furniture/42/2.jpg";
import f42_3 from "./images/furniture/42/3.jpg";
import f42_4 from "./images/furniture/42/4.jpg";
import f42_5 from "./images/furniture/42/5.jpg";

import f43_1 from "./images/furniture/43/1.jpg";
import f43_2 from "./images/furniture/43/2.jpg";
import f43_3 from "./images/furniture/43/3.jpg";
import f43_4 from "./images/furniture/43/4.jpg";
import f43_5 from "./images/furniture/43/5.jpg";

import f44_1 from "./images/furniture/44/1.jpg";
import f44_2 from "./images/furniture/44/2.jpg";
import f44_3 from "./images/furniture/44/3.jpg";
import f44_4 from "./images/furniture/44/4.jpg";
import f44_5 from "./images/furniture/44/5.jpg";

import f45_1 from "./images/furniture/45/1.jpg";
import f45_2 from "./images/furniture/45/2.jpg";
import f45_3 from "./images/furniture/45/3.jpg";
import f45_4 from "./images/furniture/45/4.jpg";

import f46_1 from "./images/furniture/46/1.jpg";
import f46_2 from "./images/furniture/46/2.jpg";
import f46_3 from "./images/furniture/46/3.jpg";
import f46_4 from "./images/furniture/46/4.jpg";

import f47_1 from "./images/furniture/47/1.jpg";
import f47_2 from "./images/furniture/47/2.jpg";
import f47_3 from "./images/furniture/47/3.jpg";
import f47_4 from "./images/furniture/47/4.jpg";
import f47_5 from "./images/furniture/47/5.jpg";

import f48_1 from "./images/furniture/48/1.jpg";
import f48_2 from "./images/furniture/48/2.jpg";
import f48_3 from "./images/furniture/48/3.jpg";
import f48_4 from "./images/furniture/48/4.jpg";

import f49_1 from "./images/furniture/49/1.jpg";
import f49_2 from "./images/furniture/49/2.jpg";
import f49_3 from "./images/furniture/49/3.jpg";
import f49_4 from "./images/furniture/49/4.jpg";

import f50_1 from "./images/furniture/50/1.jpg";
import f50_2 from "./images/furniture/50/2.jpg";
import f50_3 from "./images/furniture/50/3.jpg";
import f50_4 from "./images/furniture/50/4.jpg";
import f50_5 from "./images/furniture/50/5.jpg";

import f51_1 from "./images/furniture/51/1.jpg";
import f51_2 from "./images/furniture/51/2.jpg";
import f51_3 from "./images/furniture/51/3.jpg";
import f51_4 from "./images/furniture/51/4.jpg";

import f52_1 from "./images/furniture/52/1.jpg";
import f52_2 from "./images/furniture/52/2.jpg";
import f52_3 from "./images/furniture/52/3.jpg";
import f52_4 from "./images/furniture/52/4.jpg";
import f52_5 from "./images/furniture/52/5.jpg";

import f53_1 from "./images/furniture/53/1.jpg";
import f53_2 from "./images/furniture/53/2.jpg";
import f53_3 from "./images/furniture/53/3.jpg";
import f53_4 from "./images/furniture/53/4.jpg";
import f53_5 from "./images/furniture/53/5.jpg";

import f54_1 from "./images/furniture/54/1.jpg";
import f54_2 from "./images/furniture/54/2.jpg";
import f54_3 from "./images/furniture/54/3.jpg";
import f54_4 from "./images/furniture/54/4.jpg";

import f55_1 from "./images/furniture/55/1.jpg";
import f55_2 from "./images/furniture/55/2.jpg";
import f55_3 from "./images/furniture/55/3.jpg";
import f55_4 from "./images/furniture/55/4.jpg";

import f56_1 from "./images/furniture/56/1.jpg";
import f56_2 from "./images/furniture/56/2.jpg";
import f56_3 from "./images/furniture/56/3.jpg";
import f56_4 from "./images/furniture/56/4.jpg";
import f56_5 from "./images/furniture/56/5.jpg";
import f56_6 from "./images/furniture/56/6.jpg";

import f57_1 from "./images/furniture/57/1.jpg";
import f57_2 from "./images/furniture/57/2.jpg";
import f57_3 from "./images/furniture/57/3.jpg";
import f57_4 from "./images/furniture/57/4.jpg";
import f57_5 from "./images/furniture/57/5.jpg";

import f58_1 from "./images/furniture/58/1.jpg";
import f58_2 from "./images/furniture/58/2.jpg";
import f58_3 from "./images/furniture/58/3.jpg";
import f58_4 from "./images/furniture/58/4.jpg";

import f59_1 from "./images/furniture/59/1.jpg";
import f59_2 from "./images/furniture/59/2.jpg";
import f59_3 from "./images/furniture/59/3.jpg";
import f59_4 from "./images/furniture/59/4.jpg";
import f59_5 from "./images/furniture/59/5.jpg";
import f59_6 from "./images/furniture/59/6.jpg";

import f60_1 from "./images/furniture/60/1.jpg";
import f60_2 from "./images/furniture/60/2.jpg";
import f60_3 from "./images/furniture/60/3.jpg";
import f60_4 from "./images/furniture/60/4.jpg";
import f60_5 from "./images/furniture/60/5.jpg";

import f61_1 from "./images/furniture/61/1.jpg";
import f61_2 from "./images/furniture/61/2.jpg";
import f61_3 from "./images/furniture/61/3.jpg";
import f61_4 from "./images/furniture/61/4.jpg";
import f61_5 from "./images/furniture/61/5.jpg";

import f62_1 from "./images/furniture/62/1.jpg";
import f62_2 from "./images/furniture/62/2.jpg";
import f62_3 from "./images/furniture/62/3.jpg";
import f62_4 from "./images/furniture/62/4.jpg";

import f63_1 from "./images/furniture/63/1.jpg";
import f63_2 from "./images/furniture/63/2.jpg";
import f63_3 from "./images/furniture/63/3.jpg";
import f63_4 from "./images/furniture/63/4.jpg";

import f64_1 from "./images/furniture/64/1.jpg";
import f64_2 from "./images/furniture/64/2.jpg";
import f64_3 from "./images/furniture/64/3.jpg";
import f64_4 from "./images/furniture/64/4.jpg";
import f64_5 from "./images/furniture/64/5.jpg";

import f65_1 from "./images/furniture/65/1.jpg";
import f65_2 from "./images/furniture/65/2.jpg";
import f65_3 from "./images/furniture/65/3.jpg";
import f65_4 from "./images/furniture/65/4.jpg";

import f66_1 from "./images/furniture/66/1.jpg";
import f66_2 from "./images/furniture/66/2.jpg";
import f66_3 from "./images/furniture/66/3.jpg";
import f66_4 from "./images/furniture/66/4.jpg";
import f66_5 from "./images/furniture/66/5.jpg";

import f67_1 from "./images/furniture/67/1.jpg";
import f67_2 from "./images/furniture/67/2.jpg";
import f67_3 from "./images/furniture/67/3.jpg";
import f67_4 from "./images/furniture/67/4.jpg";

import f68_1 from "./images/furniture/68/1.jpg";
import f68_2 from "./images/furniture/68/2.jpg";
import f68_3 from "./images/furniture/68/3.jpg";
import f68_4 from "./images/furniture/68/4.jpg";

import f69_1 from "./images/furniture/69/1.jpg";
import f69_2 from "./images/furniture/69/2.jpg";
import f69_3 from "./images/furniture/69/3.jpg";
import f69_4 from "./images/furniture/69/4.jpg";
import f69_5 from "./images/furniture/69/5.jpg";
import f69_6 from "./images/furniture/69/6.jpg";

import f70_1 from "./images/furniture/70/1.jpg";
import f70_2 from "./images/furniture/70/2.jpg";
import f70_3 from "./images/furniture/70/3.jpg";
import f70_4 from "./images/furniture/70/4.jpg";

import f71_1 from "./images/furniture/71/1.jpg";
import f71_2 from "./images/furniture/71/2.jpg";
import f71_3 from "./images/furniture/71/3.jpg";
import f71_4 from "./images/furniture/71/4.jpg";

import f72_1 from "./images/furniture/72/1.jpg";
import f72_2 from "./images/furniture/72/2.jpg";
import f72_3 from "./images/furniture/72/3.jpg";
import f72_4 from "./images/furniture/72/4.jpg";
import f72_5 from "./images/furniture/72/5.jpg";

import f73_1 from "./images/furniture/73/1.jpg";
import f73_2 from "./images/furniture/73/2.jpg";
import f73_3 from "./images/furniture/73/3.jpg";

import f74_1 from "./images/furniture/74/1.jpg";
import f74_2 from "./images/furniture/74/2.jpg";
import f74_3 from "./images/furniture/74/3.jpg";
import f74_4 from "./images/furniture/74/4.jpg";
import f74_5 from "./images/furniture/74/5.jpg";

import f75_1 from "./images/furniture/75/1.jpg";
import f75_2 from "./images/furniture/75/2.jpg";
import f75_3 from "./images/furniture/75/3.jpg";
import f75_4 from "./images/furniture/75/4.jpg";

import f76_1 from "./images/furniture/76/1.jpg";
import f76_2 from "./images/furniture/76/2.jpg";
import f76_3 from "./images/furniture/76/3.jpg";
import f76_4 from "./images/furniture/76/4.jpg";
import f76_5 from "./images/furniture/76/5.jpg";

import f77_1 from "./images/furniture/77/1.jpg";
import f77_2 from "./images/furniture/77/2.jpg";
import f77_3 from "./images/furniture/77/3.jpg";
import f77_4 from "./images/furniture/77/4.jpg";

import f78_1 from "./images/furniture/78/1.jpg";
import f78_2 from "./images/furniture/78/2.jpg";
import f78_3 from "./images/furniture/78/3.jpg";
import f78_4 from "./images/furniture/78/4.jpg";

import f79_1 from "./images/furniture/79/1.jpg";
import f79_2 from "./images/furniture/79/2.jpg";
import f79_3 from "./images/furniture/79/3.jpg";
import f79_4 from "./images/furniture/79/4.jpg";

import f80_1 from "./images/furniture/80/1.jpg";
import f80_2 from "./images/furniture/80/2.jpg";
import f80_3 from "./images/furniture/80/3.jpg";
import f80_4 from "./images/furniture/80/4.jpg";
import f80_5 from "./images/furniture/80/5.jpg";

import f81_1 from "./images/furniture/81/1.jpg";
import f81_2 from "./images/furniture/81/2.jpg";
import f81_3 from "./images/furniture/81/3.jpg";

import f82_1 from "./images/furniture/82/1.jpg";
import f82_2 from "./images/furniture/82/2.jpg";
import f82_3 from "./images/furniture/82/3.jpg";
import f82_4 from "./images/furniture/82/4.jpg";
import f82_5 from "./images/furniture/82/5.jpg";

import f83_1 from "./images/furniture/83/1.jpg";
import f83_2 from "./images/furniture/83/2.jpg";
import f83_3 from "./images/furniture/83/3.jpg";
import f83_4 from "./images/furniture/83/4.jpg";

import f84_1 from "./images/furniture/84/1.jpg";
import f84_2 from "./images/furniture/84/2.jpg";
import f84_3 from "./images/furniture/84/3.jpg";
import f84_4 from "./images/furniture/84/4.jpg";

import f85_1 from "./images/furniture/85/1.jpg";
import f85_2 from "./images/furniture/85/2.jpg";
import f85_3 from "./images/furniture/85/3.jpg";
import f85_4 from "./images/furniture/85/4.jpg";
import f85_5 from "./images/furniture/85/5.jpg";
import f85_6 from "./images/furniture/85/6.jpg";

import f86_1 from "./images/furniture/86/1.jpg";
import f86_2 from "./images/furniture/86/2.jpg";
import f86_3 from "./images/furniture/86/3.jpg";
import f86_4 from "./images/furniture/86/4.jpg";
import f86_5 from "./images/furniture/86/5.jpg";

import f87_1 from "./images/furniture/87/1.jpg";
import f87_2 from "./images/furniture/87/2.jpg";
import f87_3 from "./images/furniture/87/3.jpg";

import f88_1 from "./images/furniture/88/1.jpg";
import f88_2 from "./images/furniture/88/2.jpg";
import f88_3 from "./images/furniture/88/3.jpg";
import f88_4 from "./images/furniture/88/4.jpg";
import f88_5 from "./images/furniture/88/5.jpg";

import f89_1 from "./images/furniture/89/1.jpg";
import f89_2 from "./images/furniture/89/2.jpg";
import f89_3 from "./images/furniture/89/3.jpg";
import f89_4 from "./images/furniture/89/4.jpg";
import f89_5 from "./images/furniture/89/5.jpg";
import f89_6 from "./images/furniture/89/6.jpg";
import f89_7 from "./images/furniture/89/7.jpg";
import f89_8 from "./images/furniture/89/8.jpg";

import f90_1 from "./images/furniture/90/1.jpg";
import f90_2 from "./images/furniture/90/2.jpg";
import f90_3 from "./images/furniture/90/3.jpg";
import f90_4 from "./images/furniture/90/4.jpg";

import f91_1 from "./images/furniture/91/1.jpg";
import f91_2 from "./images/furniture/91/2.jpg";
import f91_3 from "./images/furniture/91/3.jpg";
import f91_4 from "./images/furniture/91/4.jpg";
import f91_5 from "./images/furniture/91/5.jpg";

import f92_1 from "./images/furniture/92/1.jpg";
import f92_2 from "./images/furniture/92/2.jpg";
import f92_3 from "./images/furniture/92/3.jpg";
import f92_4 from "./images/furniture/92/4.jpg";
import f92_5 from "./images/furniture/92/5.jpg";

import f93_1 from "./images/furniture/93/1.jpg";
import f93_2 from "./images/furniture/93/2.jpg";
import f93_3 from "./images/furniture/93/3.jpg";
import f93_4 from "./images/furniture/93/4.jpg";
import f93_5 from "./images/furniture/93/5.jpg";
import f93_6 from "./images/furniture/93/6.jpg";

import f94_1 from "./images/furniture/94/1.jpg";
import f94_2 from "./images/furniture/94/2.jpg";
import f94_3 from "./images/furniture/94/3.jpg";
import f94_4 from "./images/furniture/94/4.jpg";
import f94_5 from "./images/furniture/94/5.jpg";

import f95_1 from "./images/furniture/95/1.jpg";
import f95_2 from "./images/furniture/95/2.jpg";
import f95_3 from "./images/furniture/95/3.jpg";
import f95_4 from "./images/furniture/95/4.jpg";

import f96_1 from "./images/furniture/96/1.jpg";
import f96_2 from "./images/furniture/96/2.jpg";
import f96_3 from "./images/furniture/96/3.jpg";

import f97_1 from "./images/furniture/97/1.jpg";
import f97_2 from "./images/furniture/97/2.jpg";
import f97_3 from "./images/furniture/97/3.jpg";

import f98_1 from "./images/furniture/98/1.jpg";
import f98_2 from "./images/furniture/98/2.jpg";
import f98_3 from "./images/furniture/98/3.jpg";
import f98_4 from "./images/furniture/98/4.jpg";

import f99_1 from "./images/furniture/99/1.jpg";
import f99_2 from "./images/furniture/99/2.jpg";
import f99_3 from "./images/furniture/99/3.jpg";
import f99_4 from "./images/furniture/99/4.jpg";

import f100_1 from "./images/furniture/100/1.jpg";
import f100_2 from "./images/furniture/100/2.jpg";
import f100_3 from "./images/furniture/100/3.jpg";
import f100_4 from "./images/furniture/100/4.jpg";

import f101_1 from "./images/furniture/101/1.jpg";
import f101_2 from "./images/furniture/101/2.jpg";
import f101_3 from "./images/furniture/101/3.jpg";
import f101_4 from "./images/furniture/101/4.jpg";

import f102_1 from "./images/furniture/102/1.jpg";
import f102_2 from "./images/furniture/102/2.jpg";
import f102_3 from "./images/furniture/102/3.jpg";
import f102_4 from "./images/furniture/102/4.jpg";

import f103_1 from "./images/furniture/103/1.jpg";
import f103_2 from "./images/furniture/103/2.jpg";
import f103_3 from "./images/furniture/103/3.jpg";
import f103_4 from "./images/furniture/103/4.jpg";

import f104_1 from "./images/furniture/104/1.jpg";
import f104_2 from "./images/furniture/104/2.jpg";
import f104_3 from "./images/furniture/104/3.jpg";
import f104_4 from "./images/furniture/104/4.jpg";
import f104_5 from "./images/furniture/104/5.jpg";
import f104_6 from "./images/furniture/104/6.jpg";

import f105_1 from "./images/furniture/105/1.jpg";
import f105_2 from "./images/furniture/105/2.jpg";
import f105_3 from "./images/furniture/105/3.jpg";

import potato from "./images/agriculture/kentang.png";
import bawang from "./images/agriculture/bawangmerah.jpg";
import ubijepang from "./images/agriculture/ubijepang.jpg";
import wortel from "./images/agriculture/wortel.jpg";
import tomat from "./images/agriculture/tomat.jpg";
import chip from "./images/agriculture/chip.jpg";

import besi1 from "./images/besi/1.png"
import besi2 from "./images/besi/2.png"
import besi3 from "./images/besi/3.jpg"
import besi4 from "./images/besi/4.png"
import besi5 from "./images/besi/5.png"
import besi6 from "./images/besi/6.png"
import besi7 from "./images/besi/7.png"
import besi8 from "./images/besi/8.png"
import besi9 from "./images/besi/9.png"
import besi10 from "./images/besi/10.jpg"
import besi11 from "./images/besi/11.png"
import besi12 from "./images/besi/12.png"
import besi13 from "./images/besi/13.png"
import besi14 from "./images/besi/14.png"
import besi15 from "./images/besi/15.png"
import besi16 from "./images/besi/16.png"
import besi18 from "./images/besi/18.png"
import besi19 from "./images/besi/19.png"
import besi20 from "./images/besi/20.jpg"

import coal1 from "./images/coal/Container2.png"

import briket1 from "./images/briket/briket1.jpg"
import briket2 from "./images/briket/briket2.jpg"

import diesel1 from "./images/biodiesel/1.jpg"
import diesel2 from "./images/biodiesel/2.png"
import diesel3 from "./images/biodiesel/3.jpg"
import diesel4 from "./images/biodiesel/4.jpg"

import nanas from "./images/agriculture/nanas.jpg"
import pisang from "./images/agriculture/pisang.jpg"

import rempah1 from "./images/rempah/1.png"
import rempah2 from "./images/rempah/2.jpeg"
import rempah3 from "./images/rempah/3.jpeg"
import rempah4 from "./images/rempah/4.png"
import rempah5 from "./images/rempah/5.png"
import rempah6 from "./images/rempah/6.jpeg"
import rempah7 from "./images/rempah/7.png"
import rempah8 from "./images/rempah/8.png"
import rempah9 from "./images/rempah/9.png"
import rempah10 from "./images/rempah/10.png"
import rempah11 from "./images/rempah/11.png"
import rempah12 from "./images/rempah/12.jpg"

export const service = [
  {
    nama: "Air Freight",
    slug: "air-feight"
  },
  {
    nama: "Sea Freight",
    slug: "sea-freight"
  },
  {
    nama: "Custom Brokerage",
    slug: "custom-brokerage"
  },
  {
    nama: "Inland Service",
    slug: "inland-service"
  },
  {
    nama: "Heavy Equipment and Oversized",
    slug: "heavy-equipment-and-oversized"
  },
  {
    nama: 'Service Local Transportation',
    slug: "service-local-transportation"
  },
  {
    nama: "Service Household Removal",
    slug: "service-household-removal"
  }
];

export const provide = [
  {
    nama: "Agriculture",
    slug: "agriculture"
  },
  {
    nama: "Steel",
    slug: "steel"
  },
  {
    nama: "Mining, Oil and Gas",
    slug: "mining-oil-and-gas"
  },
  {
    nama: "Wood Furniture",
    slug: "wood-furniture"
  },
  {
    nama: "Briquette",
    slug: "briquette"
  },
  {
    nama: "Herbs and Spices",
    slug: "herbs-and-spices"
  }
];

export const product = [
  {
    id: '1',
    nama: "Table Set – 4 Bench/Chair and 1 Coffee Table – Teak Root Coffee Table – Driftwood Coffee Table – Teak Wood Bench",
    tipe: 'furniture',
    gambar: [f1_1,f1_2,f1_3,f1_4,f1_5,f1_6],
    harga: ['2300', '2480', '2660'],
    spek: ['Height: 17.7 inches | Width : 31,4 inches', 'Height: 17.7 inches | Width : 39,3 inches', 'Height: 17.7 inches | Width : 47 inches'],
    slug: "wood-furniture"
  },
  {
    id: '2',
    nama: "Leaves Shape Carving - Teak Root Console Table – Natural Console Table – Teak Wood Console Table - Live Edge Table",
    tipe: 'furniture',
    gambar: [f2_1,f2_2,f2_3,f2_4],
    harga: ['2250'],
    spek: ['Width: 70.8 inches | Height: 31.4 inches | Depth: 17.7 inches'],
    slug: "wood-furniture"
  },
  {
    id: '3',
    nama: "Teak Root Bench – Driftwood Bench – Outdoor Furniture – Live Edge Table - Teak Wood Coffee Table",
    tipe: 'furniture',
    gambar: [f3_1,f3_2,f3_3,f3_4],
    harga: ['1950'],
    spek: ['Width: 70.8 inches | Height: 19.6 inches | Depth: 17.7 inches'],
    slug: "wood-furniture"
  },
  {
    id: '4',
    nama: "Black Square Teak Root Coffee Table – Natural Burl Coffee Table – Teak Wood Coffee Table",
    tipe: 'furniture',
    gambar: [f4_1,f4_2,f4_3,f4_4],
    harga: ['1350', '1650', '1950', '2250'],
    spek: ['Height: 17.7 inches | Width : 19.6 inches', 'Height: 17.7 inches | Width : 23.6 inches', 'Height: 17.7 inches | Width : 31.4 inches', 'Height: 17.7 inches | Width : 39.3 inches'],
    slug: "wood-furniture"
  },
  {
    id: '5',
    nama: "Teak Stump Table – Modern Teak Wood Table – Teak Wood Side Table - End Table - Night Stand - Live Edge Table - Living Room Furniture",
    tipe: 'furniture',
    gambar: [f5_1,f5_2,f5_3,f5_4,f5_5],
    harga: ['1350', '1550', '1650', '1850', '2050', '1400', '1600', '1700', '1900', '2100'],
    spek: ['Height: 15.7 inches | Width : 19.6 inches','Height: 15.7 inches | Width : 23.6 inches', 'Height: 15.7 inches | Width : 31.4 inches', 'Height: 15.7 inches | Width : 39 inches', 'Height: 15.7 inches | Width : 47 inches', 'Height: 17.7 inches | Width : 19.6 inches', 'Height: 17.7 inches | Width : 23.6 inches', 'Height: 17.7 inches | Width : 31.4 inches', 'Height: 17.7 inches | Width : 39 inches', 'Height: 17.7 inches | Width : 47 inches'],
    slug: "wood-furniture"
  },
  {
    id: '6',
    nama: "Black Round Teak Root Coffee Table – Natural Root Coffee Table – Teak Wood Coffee Table",
    tipe: 'furniture',
    gambar: [f6_1,f6_2],
    harga: ['1350', '1400', '1550', '1750', '1950', '2450', '1380', '1430', '1600' , '1800', '2000', '2500'],
    spek: ['Height: 40 Centimeters | Diameter : 50 Centimeters', 'Height: 40 Centimeters | Diameter : 60 Centimeters', 'Height: 40 Centimeters | Diameter : 80 Centimeters' ,'Height: 40 Centimeters | Diameter : 100 Centimeters', 'Height: 40 Centimeters | Diameter : 120 Centimeters', 'Height: 40 Centimeters | Diameter : 150 Centimeters', 'Height: 45 Centimeters | Diameter : 50 Centimeters' , 'Height: 45 Centimeters | Diameter : 60 Centimeters', 'Height: 45 Centimeters | Diameter : 80 Centimeters', 'Height: 45 Centimeters | Diameter : 100 Centimeters', 'Height: 45 Centimeters | Diameter : 120 Centimeters', 'Height: 45 Centimeters | Diameter : 150 Centimeters'],
    slug: 'wood-furniture'
  },
  {
    id: '7',
    nama: 'Black Round Teak Root Coffee Table – Natural Burl Coffee Table – Teak Wood Coffee Table',
    tipe: 'furniture',
    gambar: [f7_1,f7_2,f7_3,f7_4,f7_5],
    harga: ['1300', '1450', '1750', '1950', '2350', '1350', '1500', '1800', '2000', '2400'],
    spek: ['Height: 15.7 inches | Width : 19.6 inches', 'Height: 15.7 inches | Width : 23.6 inches', 'Height: 15.7 inches | Width : 31.4 inches', 'Height: 15.7 inches | Width : 39.3 inches', 'Height: 15.7 inches | Width : 47.2 inches', 'Height: 17.7 inches | Width : 19.6 inches', 'Height: 17.7 inches | Width : 23.6 inches', 'Height: 17.7 inches | Width : 31.4 inches', 'Height: 17.7 inches | Width : 39.3 inches', 'Height: 17.7 inches | Width : 47.2 inches'],
    slug: 'wood-furniture'
  },
  {
    id: '8',
    nama: 'Teak Root Bench - Root Chair - Side Table - End Table - Driftwood Table - Outdoor Furniture - Black and White',
    tipe: 'furniture',
    gambar: [f8_1,f8_2,f8_3,f8_4],
    harga: ['1110'],
    spek: ['Width: 51 inches | Height: 17.7 inches | Depth: 17.7 inches'],
    slug: 'wood-furniture'
  },
  {
    id: '9',
    nama: 'Round - Wooden Patchwork Teak Root Coffee Table – Modern Coffee Table – Teak Wood Table - Driftwood Table - Dining Room Furniture',
    tipe: 'furniture',
    gambar: [f9_1,f9_2,f9_3,f9_4,f9_5,f9_6],
    harga: ['1150', '1350', '1650', '1850', '2050', '1200', '1400', '1700', '1900', '2100'],
    spek: ['Height: 15.7 inches | Width : 19.6 inches', 'Height: 15.7 inches | Width : 23.6 inches', 'Height: 15.7 inches | Width : 27.5 inches', 'Height: 15.7 inches | Width : 31.4 inches', 'Height: 15.7 inches | Width : 39.3 inches', 'Height: 17.7 inches | Width : 19.6 inches', 'Height: 17.7 inches | Width : 23.6 inches', 'Height: 17.7 inches | Width : 31.4 inches', 'Height: 17.7 inches | Width : 39.3 inches', 'Height: 17.7 inches | Width : 47.2 inches'],
    slug: 'wood-furniture'
  },
  {
    id: "10",
    nama: "Teak Root Bench - Root Coffee Table - Side Table - End Table - Driftwood Table - Outdoor Furniture",
    tipe: "Furniture",
    gambar: [f10_1,f10_2,f10_3,f10_4],
    harga: ["1100"],
    spek: ["Width: 44 inches | Height: 17.7 inches | Depth: 13.4 inches"],
    slug: "wood-furniture"
   },
   {
    id: "11",
    nama: "Owl Wood Statue - Animal Home Décor - Natural Wood Carving -Wooden Owl Sculpture",
    tipe: "Statue and Sculpture",
    gambar: [f11_1,f11_2,f11_3,f11_4,f11_5],
    harga: ["1100"],
    spek: ["Width: 20 inches | Height: 17.2 inches | Depth: 9 inches"],
    slug: "wood-furniture"
   },
   {
    id: "12",
    tipe: "Statue and Sculpture",
    gambar: [f12_1,f12_2,f12_3,f12_4,f12_5],
    nama: "Eagle Wood Statue -  Animal Home Décor - Natural Wood Carving - Teak Wood Sculpture",
    harga: ["1100"],
    spek: ["Width: 13 inches | Height: 21 inches | Depth: 10.2 inches"],
    slug: "wood-furniture"
   },
   {
    id: "13",
    tipe: "Statue and Sculpture",
    gambar: [f13_1,f13_2,f13_3,f13_4,f13_5],
    nama: "Horse Head - Horse Wood Statue - Horse Wood Sculpture - Tree Root Art Decoration - Teak Wood Hand Carving - Wood Art",
    harga: ["2110"],
    spek: ["Width: 29.5 inches | Height: 32.2 inches | Depth: 19.2 inches"],
    slug: "wood-furniture"
   },
   {
    id: "14",
    tipe: "Statue and Sculpture",
    gambar: [f14_1,f14_2,f14_3,f14_4],
    nama: "Horse Statue - Horse Sculpture - Tree Root Art Decoration - Teak Wood Carving - Wood Horse",
    harga: ["2110"],
    spek: ["Width: 43.3 inches | Height: 17.7 inches | Depth: 13.7 inches"],
    slug: "wood-furniture"
   },
   {
    id: "15",
    tipe: "Statue and Sculpture",
    gambar: [f15_1,f15_2,f15_3,f15_4,f15_5],
    nama: "Eagle Wood Sculpture - Animal Statue - Teak Root Carving - Wood Art Decoration",
    harga: ["2110"],
    spek: ["Width: 35.4 inches | Height: 32.2 inches | Depth: 25 inches"],
    slug: "wood-furniture"
   },
   {
    id: "16",
    tipe: "Statue and Sculpture",
    gambar: [f16_1,f16_2,f16_3,f16_4,f16_5],
    nama: "Jesus Christ Wood Statue - Christmas Décor - Home Gift - Teak Wood Carving and Crafts",
    harga: ["1100"],
    spek: ["Width: 15 inches | Height: 22 inches | Depth: 14 inches"],
    slug: "wood-furniture"
   },
   {
    id: "17",
    tipe: "Statue and Sculpture",
    nama: "Forest Spirit Sculpture - Woman Face Wood Statue, Unique Home Decor, Natural Wood Carving and Vintage Crafts",
    gambar: [f17_1,f17_2,f17_3,f17_4,f17_5],
    harga: ["1100"],
    spek: ["Width: 13.7 inches | Height: 16.5 inches | Depth: 9 inches"],
    slug: "wood-furniture"
   },
   {
    id: "18",
    tipe: "Statue and Sculpture",
    nama: "Jesus Christ Wood Statue - Jesus Christ Wood Sculpture - Wood Carving - Wood Art Sculpture - Home Art Decor",
    gambar: [f18_1,f18_2,f18_3,f18_4],
    harga: ["2180"],
    spek: ["Width: 18 inches | Height: 67 inches | Depth: 12 inches"],
    slug: "wood-furniture"
   },
   {
    id: "19",
    tipe: "Statue and Sculpture",
    nama: "Gorilla Wood Statue - Animal Sculpture - Natural Wood Carving",
    gambar: [f19_1,f19_2,f19_3,f19_4,f19_5],
    harga: ["2200"],
    spek: ["Width: 15.7 inches | Height: 52 inches | Depth: 29.5 inches"],
    slug: "wood-furniture"
   },
   {
    id: "20",
    tipe: "Home Decor",
    nama: "Wooden Chicken Statue - Chicken Sculpture - Root Art Sculpture - Carved Art Object - Art Home Decor",
    gambar: [f20_1,f20_2,f20_3,f20_4],
    harga: ["3500"],
    spek: ["Width: 37.4 inches | Height: 52.4 inches | Depth: 29.5 inches"],
    slug: "wood-furniture"
   },
   {
    id: "21",
    tipe: "Home Decor",
    nama: "Wooden Rabbit Statue - Rabbit Sculpture - Root Art Sculpture - Carved Art Object - Art Home decor",
    gambar: [f21_1,f21_2,f21_3,f21_4],
    harga: ["3500"],
    spek: ["Width: 43.3 inches | Height: 59 inches | Depth: 17.7 inches"],
    slug: "wood-furniture"
   },
   {
    id: "22",
    tipe: "Home Decor",
    nama: "Wooden Leave - Carved Tree Root Decoration - Standing Sculpture - Home Living Display - Teak Wood Art Decor",
    gambar: [f22_1,f22_2,f22_3,f22_4],
    harga: ["2110"],
    spek: ["Width: 31.4 inches | Height: 63 inches | Depth: 12 inches"],
    slug: "wood-furniture"
   },
   {
    id: "23",
    tipe: "Home Decor",
    nama: "Black - Home Decoration - Art Decoration - Teak Root Carving - Wood Sculpture",
    gambar: [f23_1,f23_2,f23_3,f23_4],
    harga: ["1099"],
    spek: ["Width: 14.9 inches | Height: 31.4 inches | Depth: 12.5 inches"],
    slug: "wood-furniture"
   },
   {
    id: "24",
    tipe: "Home Decor",
    nama: "Wooden Leave - Carved Tree Root Decoration - Standing Sculpture - Home Living Display",
    gambar: [f24_1,f24_2,f24_3,f24_4,f24_5],
    harga: ["2110"],
    spek: ["Width: 37.4 inches | Height: 44 inches | Depth: 29.5 inches"],
    slug: "wood-furniture"
   },
   {
    id: "25",
    tipe: "Home Decor",
    nama: "Carved - White - Massive Teak Root Wall Panel - Wood Room Divider - Tree Root Screen - Root Home Decor",
    gambar: [f25_1,f25_2,f25_3,f25_4],
    harga: ["3500"],
    spek: ["Width: 65 inches | Height: 65 inches | Depth: 12 inches"],
    slug: "wood-furniture"
   },
   {
    id: "26",
    tipe: "Home Decor",
    nama: "Carved - Massive Teak Root Wall Panel - Wood Room Divider - Tree Root Screen - Root Home Decor",
    gambar: [f26_1,f26_2,f26_3,f26_4],
    harga: ["3500"],
    spek: ["Width: 65 inches | Height: 65 inches | Depth: 12 inches"],
    slug: "wood-furniture"
   },
   {
    id: "27",
    tipe: "Home Decor",
    nama: "Carved - Massive Teak Root Wall Panel - Wood Room Divider - Tree Root Screen - Root Home Decor",
    gambar: [f27_1,f27_2,f27_3,f27_4],
    harga: ["3500"],
    spek: ["Width: 65 inches | Height: 65 inches | Depth: 12 inches"],
    slug: "wood-furniture"
   },
   {
    id: "28",
    tipe: "Doors, Frame, Windows",
    nama: "Royal 3 Hand Carved Wood Door and Full Frame – Teak Wood Doors and Frames",
    gambar: [f28_1,f28_2,f28_3],
    harga: ["7400"],
    spek: ["Width: 177 inches | Height: 177 inches | Depth: 5.5 inches"],
    slug: "wood-furniture"
   },
   {
    id: "29",
    tipe: "Doors, Frame, Windows",
    nama: "Royal 2 Hand Carved Wood Door and Full Frame – Teak Wood Doors and Frames",
    gambar: [f29_1,f29_2,f29_3],
    harga: ["6400"],
    spek: ["Width: 177 inches | Height: 137 – 149 inches | Depth: 5.5 inches"],
    slug: "wood-furniture"
   },
   {
    id: "30",
    tipe: "Doors, Frame, Windows",
    nama: "Royal 1 Hand Carved Wood Door and Full Frame – Teak Wood Doors and Frames",
    gambar: [f30_1,f30_2,f30_3,f30_4,f30_5],
    harga: ["5400"],
    spek: ["Width: 177 inches | Height: 106 inches | Depth: 5.5 inches"],
    slug: "wood-furniture"
   },
   {
    id: "31",
    tipe: "Doors, Frame, Windows",
    nama: "Premium Hand Carved Wood Door and Full Frame - Teak Wood Doors and Frames",
    gambar: [f31_1,f31_2,f31_3,f31_4],
    harga: ["4000"],
    spek: ["Width: 177 inches | Height: 59-70 inches | Depth: 5.5 inches"],
    slug: "wood-furniture"
   },
   {
    id: "32",
    tipe: "Wall Decor",
    nama: "Wood Carving - Teak Root Wall Decoration - Natural Wood Art - Wood Sculpture - Tree Root Craft",
    gambar: [f32_1,f32_2,f32_3,f32_4],
    harga: ["1200"],
    spek: ["Width: 47 inches | Height: 47 inches | Depth: 9 inches"],
    slug: "wood-furniture"
   },
   {
    id: "33",
    tipe: "Wall Decor",
    nama: "Wood Carving - Teak Root Wall Decoration - Natural Wood Art - Wood Sculpture - Tree Root Craft - Wood Carved Wall Hanging",
    gambar: [f33_1,f33_2,f33_3,f33_4,f33_5],
    harga: ["1180"],
    spek: ["Width: 52 inches | Height: 49.2 inches | Depth: 4 inches"],
    slug: "wood-furniture"
   },
   {
    id: "34",
    tipe: "Wall Decor",
    nama: "Wood Carving - Teak Root Wall Decoration - Natural Wood Art - Wood Sculpture - Tree Root Craft - Wood Carved Wall Hanging",
    gambar: [f34_1,f34_2,f34_3,f34_4],
    harga: ["1000"],
    spek: ["Diameters: 31,4 inches | Depth: 3.2 inches"],
    slug: "wood-furniture"
   },
   {
    id: "35",
    tipe: "Wall Decor",
    nama: "Wood Carving - Teak Root Wall Decoration - Natural Wood Art - Wood Sculpture - Tree Root Craft - Wood Carved Wall Hanging",
    gambar: [f35_1,f35_2,f35_3,f35_4,f35_5],
    harga: ["1000"],
    spek: ["Width: 32 inches | Height: 32 inches | Depth: 3.2 inches"],
    slug: "wood-furniture"
   },
   {
    id: "36",
    tipe: "Wall Decor",
    nama: "Wood Carving - Teak Root Wall Decoration - Natural Wood Art - Wood Sculpture - Tree Root Craft - Wood Carved Wall Hanging",
    gambar: [f36_1,f36_2,f36_3,f36_4,f36_5],
    harga: ["1000"],
    spek: ["Width: 31.4 inches | Height: 35.4 inches | Depth: 4 inches"],
    slug: "wood-furniture"
   },
   {
    id: "37",
    tipe: "Wall Decor",
    nama: "Wood Carving - Teak Root Wall Decoration - Natural Wood Art - Wood Sculpture - Tree Root Craft",
    gambar: [f37_1,f37_2,f37_3,f37_4,f37_5],
    harga: ["1000"],
    spek: ["Width: 27 inches | Height: 35 inches | Depth: 3 inches"],
    slug: "wood-furniture"
   },
   {
    id: "38",
    tipe: "Golden Acacia Furniture",
    nama: "Golden Acacia Coffee Table – Live Edge Table – Living Room Furniture – Monkey Pot Coffee Table",
    gambar: [f38_1,f38_2,f38_3,f38_4,f38_5],
    harga: ["2050"],
    spek: ["Width: 61 inches | Height: 17.7 inches | Depth: 41.5 inches"],
    slug: "wood-furniture"
   },
   {
    id: "39",
    tipe: "Golden Acacia Furniture",
    nama: "Carved Console Table – Entryway Table- Bar Table - Live Edge Table – Living Room Furniture – Tree Root Console Table",
    gambar: [f39_1,f39_2,f39_3,f39_4,f39_5,f39_6],
    harga: ["1700"],
    spek: ["Width: 52 inches | Height: 36 inches | Depth: 14 inches"],
    slug: "wood-furniture"
   },
   {
    id: "40",
    tipe: "Golden Acacia Furniture",
    nama: "Golden Acacia Console Table – Live Edge Table – Living Room Furniture – Tree Root Console Table – TV Table",
    gambar: [f40_1,f40_2,f40_3,f40_4,f40_5],
    harga: ["1700"],
    spek: ["Width: 59 inches | Height: 31.4 inches | Depth: 15.7 inches"],
    slug: "wood-furniture"
   },
   {
    id: "41",
    tipe: "Golden Acacia Furniture",
    nama: "Walnut Coffee Table - Acacia Live Edge Table - Suar Wood Table - Side Table - End Table - Sofa Table",
    gambar: [f41_1,f41_2,f41_3,f41_4,f41_5],
    harga: ["1600"],
    spek: ["Width: 55 inches | Height: 18 inches | Depth: 23.6 inches"],
    slug: "wood-furniture"
   },
   {
    id: "42",
    tipe: "Golden Acacia Furniture",
    nama: "Golden Acacia Console Table – Live Edge Table – Living Room Furniture – Tree Root Console Table - TV Table",
    gambar: [f42_1,f42_2,f42_3,f42_4,f42_5],
    harga: ["1500"],
    spek: ["Width: 47.2 inches | Height: 29.5 inches | Depth: 18 inches"],
    slug: "wood-furniture"
   },
   {
    id: "43",
    tipe: "Golden Acacia Furniture",
    nama: "Golden Acacia Console Table – Live Edge Table – Living Room Furniture – Tree Root Console Table – TV Table",
    gambar: [f43_1,f43_2,f43_3,f43_4,f43_5],
    harga: ["1500"],
    spek: ["Width: 47.2 inches | Height: 29.5 inches | Depth: 19.6 inches"],
    slug: "wood-furniture"
   },
   {
    id: "44",
    tipe: "Golden Acacia Furniture",
    nama: "Tree Root Bench - Outdoor Chair - Wood Stool - Walnut Coffee Table - End Table - Side Table - Entryway Table",
    gambar: [f44_1,f44_2,f44_3,f44_4,f44_5],
    harga: ["1600"],
    spek: ["Width: 59 inches | Height: 19 inches | Depth: 15.7 inches"],
    slug: "wood-furniture"
   },
   {
    id: "45",
    tipe: "Golden Acacia Furniture",
    nama: "Golden Acacia Console Table – Entryway Table- Bar Table - Live Edge Table – Living Room Furniture – Tree Root Console Table",
    gambar: [f45_1,f45_2,f45_3,f45_4],
    harga: ["1600"],
    spek: ["Width: 59 inches | Height: 33 inches | Depth: 15.7 inches"],
    slug: "wood-furniture"
   },
   {
    id: "46",
    tipe: "Golden Acacia Furniture",
    nama: "Golden Acacia Coffee Table – Live Edge Table – Living Room Furniture – Tree Stump Coffee Table",
    gambar: [f46_1,f46_2,f46_3,f46_4],
    harga: ["1400"],
    spek: ["Width: 37 inches | Height: 16.5 inches | Depth: 31.4 inches"],
    slug: "wood-furniture"
   },
   {
    id: "47",
    tipe: "Golden Acacia Furniture",
    nama: "Golden Acacia Coffee Table – Live Edge Table – Living Room Furniture – Tree Stump Coffee Table",
    gambar: [f47_1,f47_2,f47_3,f47_4,f47_5],
    harga: ["1400"],
    spek: ["Width: 34.2 inches | Height: 17.7 inches | Depth: 23.6 inches"],
    slug: "wood-furniture"
   },
   {
    id: "48",
    tipe: "Golden Acacia Furniture",
    nama: "Golden Acacia Cocktail Table – Golden Acacia Side Table – Golden Acacia End Table – Live Edge Table – Sofa Table – Entry Room Table",
    gambar: [f48_1,f48_2,f48_3,f48_4],
    harga: ["1200"],
    spek: ["Width: 15.7 inches | Height: 29.5 inches | Depth: 15.7 inches"],
    slug: "wood-furniture"
   },
   {
    id: "49",
    tipe: "Wood Exotic Furniture",
    nama: "Round Carving Table - Flower Shape - Tree Root Coffee Table – Walnut Table - Rosewood Table - Sculpture Coffee Table",
    gambar: [f49_1,f49_2,f49_3,f49_4],
    harga: ["2200"],
    spek: ["Width: 47.2 inches | Height: 17.7 inches | Depth: 47.2 inches"],
    slug: "wood-furniture"
   },
   {
    id: "50",
    tipe: "Wood Exotic Furniture",
    nama: "Rectangular - Tree Root Coffee Table – Walnut Table - Rosewood Table - Exotic Wood Coffee Table",
    gambar: [f50_1,f50_2,f50_3,f50_4,f50_5],
    harga: ["1680"],
    spek: ["Width: 39.3 inches | Height: 17.7 inches | Depth: 31.4 inches"],
    slug: "wood-furniture"
   },
   {
    id: "51",
    tipe: "Wood Exotic Furniture",
    nama: "Round Flower Shape - Tree Root Coffee Table – Walnut Table - Rosewood Table - Sculpture Coffee Table",
    gambar: [f51_1,f51_2,f51_3,f51_4],
    harga: ["1850"],
    spek: ["Width: 39.3 inches | Height: 17.7 inches | Depth: 39.3 inches"],
    slug: "wood-furniture"
   },
   {
    id: "52",
    tipe: "Wood Exotic Furniture",
    nama: "Walnut Console Table - Entryway Table - Acacia Side Table - Live Edge Table",
    gambar: [f52_1,f52_2,f52_3,f52_4,f52_5],
    harga: ["1700"],
    spek: ["Width: 41 inches | Height: 30.3 inches | Depth: 17.7 inches"],
    slug: "wood-furniture"
   },
   {
    id: "53",
    tipe: "Wood Exotic Furniture",
    nama: "Walnut Console Table - Entryway Table - Acacia Side Table - Live Edge Table",
    gambar: [f53_1,f53_2,f53_3,f53_4,f53_5],
    harga: ["1550"],
    spek: ["Width: 31.5 inches | Height: 30 inches | Depth: 17 inches"],
    slug: "wood-furniture"
   },
   {
    id: "54",
    tipe: "Dining Table",
    nama: "Round Mushroom - Teak Root Dining Table – Tree Root Table – Live Edge Table – Living Room Table",
    gambar: [f54_1,f54_2,f54_3,f54_4],
    harga: ["2250"],
    spek: ["Height: 47 inches | Width : 31,4 inches"],
    slug: "wood-furniture"
   },
   {
    id: "55",
    tipe: "Dining Table",
    nama: "White - Carving Table - Flower Shape - Round Teak Stump Dining Table – Tree Stump Dining Table – Teak Wood Dining Table - Live Edge Table",
    gambar: [f55_1,f55_2,f55_3,f55_4],
    harga: ["1950","2150","2350","2650","2000","2200","2400","2700"],
    spek: ["Height: 29.5 Inches | Diameter: 31.4 inches","Height: 29.5 Inches | Diameter: 35.4 inches","Height: 29.5 inches | Diameter: 39.3 inches","Height: 29.5 inches| Diameter: 47.2 inches","Height: 31.4 inches | Diameter: 31.4 inches","Height: 31.4 inches | Diameter: 35.4 inches","Height: 31.4 inches | Diameter: 39.3 inches","Height: 31.4 inches | Diameter: 47.2 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "56",
    tipe: "Dining Table",
    nama: "White Djembe Teak Root Dining Table – Tree Root Dining Table – Teak Wood Table - Dining Room Furniture",
    gambar: [f56_1,f56_2,f56_3,f56_4,f56_5,f56_6],
    harga: ["1850", "2250","1900","2300"],
    spek: ["Height: 75 Centimeters| Diameter: 80 Centimeters", "Height: 75 Centimeters| Diameter: 100 Centimeters","Height: 80 Centimeters| Diameter: 80 Centimeters","Height: 80 Centimeters| Diameter: 100 Centimeters"],
    slug: 'wood-furniture'
   },
   {
    id: "57",
    tipe: "Dining Table",
    nama: "Round Cone - Teak Stump Table – Modern Dining Table – Natural Teak Wood Dining Table - Dining Room Furniture - Live Edge Table",
    gambar: [f57_1,f57_2,f57_3,f57_4,f57_5],
    harga: ["1650","2050","2350","2650"],
    spek: ["Height: 31.4 Inches | Diameter: 23.6 inches", "Height: 31.4 Inches | Diameter: 31.4 inches","Height: 31.4 Inches | Diameter: 39.3 inches","Height: 31.4 Inches | Diameter: 47.2 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "58",
    tipe: "Dining Table",
    nama: "White Round Cone - Teak Stump Table – Modern Dining Table – Natural Teak Wood Dining Table - Dining Room Furniture",
    gambar: [f58_1,f58_2,f58_3,f58_4],
    harga: ["1550","1850","2150","2450","1600","1900","2200","2500"],
    spek: ["Height: 29.5 inches | Diameter: 23.6 inches","Height: 29.5 inches | Diameter: 31.4 inches","Height: 29.5 inches | Diameter: 39.3 inches","Height: 29.5 inches | Diameter: 47.2 inches","Height: 31.4 inches | Diameter: 23.6 inches","Height: 31.4 inches | Diameter: 31.4 inches","Height: 31.4 inches | Diameter: 39.3 inches","Height: 31.4 inches | Diameter: 47.2 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "59",
    tipe: "Dining Table",
    nama: "Carving Table - Flower Shape - Round Teak Stump Dining Table – Tree Stump Dining Table – Teak Wood Dining Table - Dining Room Furniture",
    gambar: [f59_1,f59_2,f59_3,f59_4,f59_5,f59_6],
    harga: ["1550","2050","2350","2650","1600","2100","2400","2700",],
    spek: ["Height: 29.5 inches | Diameter: 23.6 inches","Height: 29.5 inches | Diameter: 31.4 inches","Height: 29.5 inches | Diameter: 39 inches","Height: 29.5 inches | Diameter: 47.2 inches","Height: 31.4 inches | Diameter: 23.6 inches","Height: 31.4 inches | Diameter: 31.4 inches","Height: 31.4 inches | Diameter: 39 inches","Height: 31.4 inches | Diameter: 47.2 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "60",
    tipe: "Coffee Table",
    nama: "White - Square Teak Root Coffee Table – Teak Wood Coffee Table - Tree Root Table - Driftwood Coffee Table",
    gambar: [f60_1,f60_2,f60_3,f60_4,f60_5],
    harga: ["1400","1600","1800","2000","2400",],
    spek: ["Height: 17.7 inches | Width : 19.6 inches","Height: 17.7 inches | Width : 23.6 inches","Height: 17.7 inches | Width : 31.4 inches","Height: 17.7 inches | Width : 39 inches","Height: 17.7 inches | Width : 47 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "61",
    tipe: "Coffee Table",
    nama: "Acacia Coffee Table - Side Table - End Table - Sofa Table - Acacia Stool - Bench - Outdoor Chair",
    gambar: [f61_1,f61_2,f61_3,f61_4,f61_5],
    harga: ["1150"],
    spek: ["Width: 23.6 inches | Height: 17.7 inches | Depth: 23.6 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "62",
    tipe: "Coffee Table",
    nama: "Carving Table - Flower Shape - Teak Root Coffee Table – Side Table - End Table - Outdoor Table - Accent Table",
    gambar: [f62_1,f62_2,f62_3,f62_4],
    harga: ["2150"],
    spek: ["Width: 47.2 inches | Height: 18 inches | Depth: 47.2 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "63",
    tipe: "Coffee Table",
    nama: "Teak Wood Slab Table - Live Edge Table - Outdoor Table - Gardening Tree Root Table",
    gambar: [f63_1,f63_2,f63_3,f63_4],
    harga: ["2200"],
    spek: ["Width: 61 inches | Height: 26.3 inches | Depth: 29.5 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "64",
    tipe: "Coffee Table",
    nama: "Carving Table - Flower Shape Round - Teak Root Coffee Table – Natural Root Coffee Table – Teak Wood Coffee Table",
    gambar: [f64_1,f64_2,f64_3,f64_4,f64_5],
    harga: ["1850"],
    spek: ["Width: 39.3 inches | Height: 17.7 inches | Depth: 39.3 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "65",
    tipe: "Coffee Table",
    nama: "Carving Table - Flower Shape Round - Teak Root Coffee Table - Driftwood Table - Live Edge Table - Wood Sculpture",
    gambar: [f65_1,f65_2,f65_3,f65_4],
    harga: ["1600"],
    spek: ["Width: 31.4 inches | Height: 17.7 inches | Depth: 31.4 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "66",
    tipe: "Coffee Table",
    nama: "Teak Wood Slab Table - Erosion Root Table - Rustic Live Edge Table - Driftwood Table - Outdoor Table",
    gambar: [f66_1,f66_2,f66_3,f66_4,f66_5],
    harga: ["1930"],
    spek: ["Width: 51 inches | Height: 24 inches | Depth: 25 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "67",
    tipe: "Coffee Table",
    nama: "Teak Root Coffee Table - Live Edge Table - Driftwood Table - Rustic Coffee Table - Rectangular Table",
    gambar: [f67_1,f67_2,f67_3,f67_4],
    harga: ["1300"],
    spek: ["Width: 31.4 inches | Height: 15.7 inches | Depth: 23.6 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "68",
    tipe: "Coffee Table",
    nama: "Square - Wooden Patchwork Teak Root Coffee Table – Reclaimed Coffee Table – Teak Wood Table - Driftwood Table",
    gambar: [f68_1,f68_2,f68_3,f68_4],
    harga: ["1030","1200","1500","1650","1830","1100","1250","1530","1710","1880",],
    spek: ["Height: 15.7 inches | Width : 15.7 inches","Height: 15.7 inches | Width : 19.6 inches","Height: 15.7 inches | Width : 23.6 inches","Height: 15.7 inches | Width : 31.5 inches","Height: 15.7 inches | Width : 39.4 inches","Height: 17.7 inches | Width : 19.6 inches","Height: 17.7 inches | Width : 23.6 inches","Height: 17.7 inches | Width : 31.4 inches","Height: 17.7 inches | Width : 39 inches","Height: 17.7 inches | Width : 47 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "69",
    tipe: "Coffee Table",
    nama: "Teak Root Coffee Table - Live Edge Table - Outdoor Table - Driftwood Table - Tree Root Sofa Table",
    gambar: [f69_1,f69_2,f69_3,f69_4,f69_5,f69_6],
    harga: ["2600"],
    spek: ["Width: 63 inches | Height: 23.6 inches | Depth: 63 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "70",
    tipe: "Coffee Table",
    nama: "Square Carving Table - Flower Shape - Square Teak Root Coffee Table – Natural Root Coffee Table – Driftwood Coffee Table - Live Edge Table",
    gambar: [f70_1,f70_2,f70_3,f70_4],
    harga: ["1450","1550","1850","2050","2350","2750","1500","1600","1900","2100","2400","2800",],
    spek: ["Height: 15.7 inches | Width : 19.6 inches","Height: 15.7 inches | Width : 23.6 inches","Height: 15.7 inches | Width : 31.4 inches","Height: 15.7 inches | Width : 39.3 inches","Height: 15.7 inches | Width : 47.2 inches","Height: 15.7 inches | Width : 59 inches","Height: 17.7 inches | Width : 19.6 inches","Height: 17.7 inches | Width : 23.6 inches","Height: 17.7 inches | Width : 31.4 inches","Height: 17.7 inches | Width : 39.3 inches","Height: 17.7 inches | Width : 47.2 inches","Height: 17.7 inches | Width : 59 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "71",
    tipe: "Coffee Table",
    nama: "White Round Teak Root Coffee Table – Natural Root Coffee Table – Teak Wood Coffee Table",
    gambar: [f71_1,f71_2,f71_3,f71_4],
    harga: ["1300","1450","1750","1950","2250","2650","1350","1500","1800","2000","2300","2700",],
    spek: ["Height: 15.7 inches | Width : 19.6 inches","Height: 15.7 inches | Width : 23.6 inches","Height: 15.7 inches | Width : 31.4 inches","Height: 15.7 inches | Width : 39.3 inches","Height: 15.7 inches | Width : 47.2 inches","Height: 15.7 inches | Width : 59 inches","Height: 17.7 inches | Width : 19.6 inches","Height: 17.7 inches | Width : 23.6 inches","Height: 17.7 inches | Width : 31.4 inches","Height: 17.7 inches | Width : 39.3 inches","Height: 17.7 inches | Width : 47.2 inches","Height: 17.7 inches | Width : 59 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "72",
    tipe: "Coffee Table",
    nama: "Hole – Teak Wood Table – Teak Wood Bench – Teak Wood Garden Furniture – Live Edge Table",
    gambar: [f72_1,f72_2,f72_3,f72_4,f72_5],
    harga: ["1400"],
    spek: ["Width: 38.5 inches | Height: 17.7 inches | Depth: 23.6 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "73",
    tipe: "Coffee Table",
    nama: "Hole – Teak Wood Table – Teak Wood Bench – Teak Wood Garden Furniture – Live Edge Table",
    gambar: [f73_1,f73_2,f73_3],
    harga: ["1400"],
    spek: ["Width: 37 inches | Height: 17.7 inches | Depth: 19.6 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "74",
    tipe: "Coffee Table",
    nama: "Round - Teak Root Coffee Table – Teak Wood Coffee Table – Root Side Table - Live Edge Table - Driftwood Table",
    gambar: [f74_1,f74_2,f74_3,f74_4,f74_5],
    harga: ["1400","1650","1850","2150","1450","1700","1900","2200",],
    spek: ["Height: 15.7 inches | Width : 23.6 inches","Height: 15.7 inches | Width : 31.4 inches","Height: 15.7 inches | Width : 39.3 inches","Height: 15.7 inches | Width : 47.2 inches","Height: 17.7 inches | Width : 23.6 inches","Height: 17.7 inches | Width : 31.4 inches","Height: 17.7 inches | Width : 39.3 inches","Height: 17.7 inches | Width : 47.2 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "75",
    tipe: "Coffee Table",
    nama: "Square - Tree Root Coffee Table – Outdoor Coffee Table – Teak Wood Table - Side Table - End Table - Live Edge Table",
    gambar: [f75_1,f75_2,f75_3,f75_4],
    harga: ["1450","1650","1850","2150","1500","1700","1900","2200",],
    spek: ["Height: 15.7 inches | Width : 19.6 inches", "Height: 15.7 inches | Width : 23.6 inches","Height: 15.7 inches | Width : 31.4 inches","Height: 15.7 inches | Width : 39 inches","Height: 17.7 inches | Width : 19.6 inches","Height: 17.7 inches | Width : 23.6 inches","Height: 17.7 inches | Width : 31.4 inches","Height: 17.7 inches | Width : 39.3 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "76",
    tipe: "Coffee Table",
    nama: "Black Star - Teak Stump Table – Teak Wood End Table – Teak Wood Side Table - Outdoor Table - Live Edge Table",
    gambar: [f76_1,f76_2,f76_3,f76_4,f76_5],
    harga: ["1450","1550","1750","1950",],
    spek: ["Height: 17.7 inches | Diameter : 19.6 inches","Height: 17.7 inches | Diameter : 23.6 inches","Height: 17.7 inches | Diameter : 31.4 inches","Height: 17.7 inches | Diameter : 39.3 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "77",
    tipe: "Coffee Table",
    nama: "White Round - Teak Root Coffee Table – Tree Root Table – End Table - Side Table - Night Stand - Live Edge Table - Living Room Furniture",
    gambar: [f77_1,f77_2,f77_3,f77_4],
    harga: ["1400","1500","1600","1800","2150",],
    spek: ["Height: 17.7 inches | Width : 19.6 inches","Height: 17.7 inches | Width : 23.6 inches","Height: 17.7 inches | Width : 31.4 inches","Height: 17.7 inches | Width : 39.3 inches","Height: 17.7 inches | Width : 47.2 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "78",
    tipe: "Coffee Table",
    nama: "Log Coffee Table – Wood Coffee Table – End Table - Live Edge Table - Night Stand - Side Table",
    gambar: [f78_1,f78_2,f78_3,f78_4],
    harga: ["800","900","1100","1400"],
    spek: ["Height: 15.7 inches | Width : 19.6 inches","Height: 15.7 inches | Width : 23.6 inches","Height: 15.7 inches | Width : 27.5 inches","Height: 15.7 inches | Width : 31.5 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "79",
    tipe: "Coffee Table",
    nama: "Carved Table - Sculpture Table - Fish Sculpture - Teak Root Coffee Table - Live Edge Table - Driftwood Table",
    gambar: [f79_1,f79_2,f79_3,f79_4],
    harga: ["2350"],
    spek: ["Width: 47.2 inches | Height: 19.6 inches | Depth: 47.2 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "80",
    tipe: "Coffee Table",
    nama: "Round Teak Root Coffee Table – Round Teak Root Side Table – Round End Table – Live Edge Table – Rustic Table",
    gambar: [f80_1,f80_2,f80_3,f80_4,f80_5],
    harga: ["900"],
    spek: ["Width: 23.6 inches | Height: 17.7 inches | Depth: 23.6 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "81",
    tipe: "Coffee Table",
    nama: "Rectangular - Natural Teak Root Coffee Table – Tree Root Side Table – Live Edge Table - Driftwood Table",
    gambar: [f81_1,f81_2,f81_3],
    harga: ["1850","2050"],
    spek: ["Width: 39.3 inches | Height: 17.7 inches | Depth: 31.4 inches", "Width: 47.2 inches | Height: 17.7 inches | Depth: 31.4 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "82",
    tipe: "Coffee Table",
    nama: "Rectangle - White - Teak Root Coffee Table – Tree Root Coffee Table – Teak Wood Coffee Table - Live Edge Table - Driftwood Table",
    gambar: [f82_1,f82_2,f82_3,f82_4,f82_5],
    harga: ["1730"],
    spek: ["Width: 39.3 inches | Height: 17.7 inches | Depth: 31.4 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "83",
    tipe: "Coffee Table",
    nama: "Natural - Square Teak Root Coffee Table – Teak Wood Coffee Table - Tree Root Table - Driftwood Coffee Table",
    gambar: [f83_1,f83_2,f83_3,f83_4],
    harga: ["1300","1350","1550","1700","1950"],
    spek: ["Width: 19.6 inches | Height: 17.7 inches","Width: 23.6 inches | Height: 17.7 inches","Width: 31.4 inches | Height: 17.7 inches","Width: 39.3 inches | Height: 17.7 inches","Width: 47.2 inches | Height: 17.7 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "84",
    tipe: "Coffee Table",
    nama: "White Square - Teak Root Coffee Table – Tree Root Side Table – Teak Wood End Table - Live Edge Table - Driftwood Table",
    gambar: [f84_1,f84_2,f84_3,f84_4],
    harga: ["1050"],
    spek: ["Width: 19.6 inches | Height: 17.7 inches | Depth: 19.6 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "85",
    tipe: "Coffee Table",
    nama: "Rectangular - White - Teak Root Coffee Table – Tree Root Side Table – Live Edge Table - Driftwood Table ( Best Seller )",
    gambar: [f85_1,f85_2,f85_3,f85_4,f85_5,f85_6],
    harga: ["1850", "2050"],
    spek: ["Width: 39.3 inches | Height: 17.7 inches | Depth: 31.4 inches", "Width: 47.2 inches | Height: 17.7 inches | Depth: 31.4 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "86",
    tipe: "Coffee Table",
    nama: "Black Square - Wooden Patchwork Coffee Table – Outdoor Coffee Table – Teak Root Side Table - Driftwood Table",
    gambar: [f86_1,f86_2,f86_3,f86_4,f86_5],
    harga: ["1700"],
    spek: ["Width: 31.4 inches | Height: 17.7 inches | Depth: 31.4 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "87",
    tipe: "Coffee Table",
    nama: "White Square - Teak Root Coffee Table – Tree Root Coffee Table – Teak Wood Coffee Table - Live Edge Table - Driftwood Table",
    gambar: [f87_1,f87_2,f87_3],
    harga: ["1350","1550","1850","2250","1400","1600","1900","2300",],
    spek: "Height: 15.7 inches | Width : 19.6 inches",
    slug: 'wood-furniture'
   },
   {
    id: "88",
    tipe: "Coffee Table",
    nama: "Round - Teak Root Coffee Table – Tree Root Coffee Table – Live Edge Table - End Table - Side Table - Night Stand - Living Room Furniture",
    gambar: [f88_1,f88_2,f88_3,f88_4,f88_5],
    harga: ["1400","1500","1650","1850","2150","2450","1450","1550","1700","1900","2200","2500",],
    spek: ["Height: 15.7 inches | Width : 19.6 inches","Height: 15.7 inches | Width : 23.6 inches","Height: 15.7 inches | Width : 31.4 inches","Height: 15.7 inches | Width : 39.3 inches","Height: 15.7 inches | Width : 47.2 inches","Height: 15.7 inches | Width : 59 inches","Height: 17.7 inches | Diameter : 19.6 inches","Height: 17.7 inches | Diameter : 23.6 inches","Height: 17.7 inches | Diameter : 31.4 inches","Height: 17.7 inches | Diameter : 39.3 inches","Height: 17.7 inches | Width : 47.2 inches","Height: 17.7 inches | Width : 59 inches", ],
    slug: 'wood-furniture'
   },
   {
    id: "89",
    tipe: "Coffee Table",
    nama: "White - Flower Shape - Round Teak Root Coffee Table – Carving Table - Natural Root Coffee Table – Living Home Furniture ( Best Seller )",
    gambar: [f89_1,f89_2,f89_3,f89_4,f89_5,f89_6,f89_7,f89_8],
    harga: ["1450","1650","1850","2150","1500","1700","1900","2200",],
    spek: ["Height: 15.7 inches | Width : 23.6 inches","Height: 15.7 inches | Width : 31.4 inches","Height: 15.7 inches | Width : 39.3 inches","Height: 15.7 inches | Width : 47.2 inches","Height: 17.7 inches | Diameter : 23.6 inches","Height: 17.7 inches | Diameter : 31.4 inches","Height: 17.7 inches | Diameter : 39.3 inches","Height: 17.7 inches | Width : 47.2 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "90",
    tipe: "Coffee Table",
    nama: "Round Teak Root Coffee Table – Round Teak Root Side Table – Round End Table – Live Edge Table",
    gambar: [f90_1,f90_2,f90_3,f90_4],
    harga: ["1250"],
    spek: ["Width: 23.6 inches | Height: 19.6 inches | Depth: 23.6 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "91",
    tipe: "Coffee Table",
    nama: "Carving Table - Flower Shape Round - Natural Teak Root Coffee Table – Teak Wood Sculpture Table – Wood Art Table ( Best Seller )",
    gambar: [f91_1,f91_2,f91_3,f91_4,f91_5],
    harga: ["1300","1550","1750","1950","2250","2650","1350","1600","1800","2000","2300","2700",],
    spek: ["Height: 15.7 inches | Width : 19.6 inches", "Height: 15.7 inches | Width : 23.6 inches","Height: 15.7 inches | Width : 31.4 inches","Height: 15.7 inches | Width : 39.3 inches","Height: 15.7 inches | Width : 47.2 inches","Height: 15.7 inches | Width : 59 inches","Height: 17.7 inches | Diameter : 19.6 inches","Height: 17.7 inches | Diameter : 23.6 inches","Height: 17.7 inches | Diameter : 31.4 inches","Height: 17.7 inches | Diameter : 39.3 inches","Height: 17.7 inches | Width : 47.2 inches","Height: 17.7 inches | Width : 59 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "92",
    tipe: "Console and Bar Table",
    nama: "Carving Table - Leaves Shape - Teak Root Console Table – Rustic Console Table – Teak Wood Table – Living Room Furniture",
    gambar: [f92_1,f92_2,f92_3,f92_4,f92_5],
    harga: ["1850"],
    spek: ["Width: 47 inches | Height: 31 inches | Depth: 15.7 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "93",
    tipe: "Console and Bar Table",
    nama: "White - Leaves Shape Carving - Teak Root Console Table – Natural Console Table – Teak Wood Console Table - Live Edge Table",
    gambar: [f93_1,f93_2,f93_3,f93_4,f93_5,f93_6],
    harga: ["1550","1750","2050","2250","2450","1600","1800","2100","2300","2500",],
    spek: ["Height: 29.5 inches | Diameter: 39.3 inches","Height: 29.5 inches | Diameter: 47.2 inches","Height: 29.5 inches | Diameter: 59 inches","Height: 29.5 inches | Diameter: 70.8 inches","Height: 29.5 inches | Diameter: 78.7 inches","Height: 31.4 inches | Diameter: 39.3 inches","Height: 31.4 inches | Diameter: 47.2 inches","Height: 31.4 inches | Diameter: 59 inches","Height: 31.4 inches | Diameter: 70.8 inches","Height: 31.4 inches | Diameter: 78.7 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "94",
    tipe: "Console and Bar Table",
    nama: "Carving - Teak Root Bar Table - Wood Console Table - Entryway Table - Wood Sculpture",
    gambar: [f94_1,f94_2,f94_3,f94_4,f94_5],
    harga: ["1900"],
    spek: ["Width: 47.2 inches | Height: 40 inches | Depth: 17.7 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "95",
    tipe: "Console and Bar Table",
    nama: "Teak Root Console Table – Natural Console Table – Teak Wood Console Table - Root Bar Table - Live Edge Table",
    gambar: [f95_1,f95_2,f95_3,f95_4],
    harga: ["2420"],
    spek: ["Width: 78.7 inches | Height: 31.4 inches | Depth: 17.7 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "96",
    tipe: "Console and Bar Table",
    nama: "Leaves Shape Carving - Teak Root Console Table – Driftwood Console Table – Teak Wood Console Table - Live Edge Table - Roots Bar Table",
    gambar: [f96_1,f96_2,f96_3],
    harga: ["2450"],
    spek: ["Width: 78.7 inches | Height: 31.4 inches | Depth: 17.7 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "97",
    tipe: "Console and Bar Table",
    nama: "Teak Root Console Table – Root Bar Table - Entryway Table - Driftwood Table – Teak Wood Console Table - Live Edge Table",
    gambar: [f97_1,f97_2,f97_3],
    harga: ["2150"],
    spek: ["Width: 70.9 inches | Height: 31.4 inches | Depth: 15.7 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "98",
    tipe: "Console and Bar Table",
    nama: "TV Table – Rustic Teak Root Table – Teak Wood Console Table – Live Edge Table – Living Room Furniture – Driftwood Console Table",
    gambar: [f98_1,f98_2,f98_3,f98_4],
    harga: ["1650"],
    spek: ["Width: 48 inches | Height: 31.4 inches | Depth: 16.9 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "99",
    tipe: "Console and Bar Table",
    nama: "Teak Wood Console Table - Driftwood Console Table - Teak Root Console Table - Live Edge Table - Workbench - Office Table",
    gambar: [f99_1,f99_2,f99_3,f99_4],
    harga: ["1750"],
    spek: ["Width: 63.7 inches | Height: 29.5 inches | Depth: 14 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "100",
    tipe: "Console and Bar Table",
    nama: "Teak Root Console Table – Natural Console Table – Teak Wood Console Table - Root Bar Table - Live Edge Table",
    gambar: [f100_1,f100_2,f100_3,f100_4],
    harga: ["1550","1750","1950","2150","2450"],
    spek: ["Height: 31.4 inches | Diameter: 39.3 inches","Height: 31.4 inches | Diameter: 47.2 inches","Height: 31.4 inches | Diameter: 59 inches","Height: 31.4 inches | Diameter: 70.8 inches","Height: 31.4 inches | Diameter: 78.7 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "101",
    tipe: "Console and Bar Table",
    nama: "Display Wooden Table - Tree Root Table - Teak Root Console Table - Driftwood Table - Entryway Table",
    gambar: [f101_1,f101_2,f101_3,f101_4],
    harga: ["2150"],
    spek: ["Width: 57 inches | Height: 37.4 inches | Depth: 21.6 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "102",
    tipe: "Console and Bar Table",
    nama: "Leaves Shape - Teak Root Console Table – Hand Carved Console Table – Teak Wood Console Table – Live Edge Table",
    gambar: [f102_1,f102_2,f102_3,f102_4],
    harga: ["1850"],
    spek: ["Width: 51 inches | Height: 31.4 inches | Depth: 17.7 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "103",
    tipe: "Console and Bar Table",
    nama: "Bar Stools – Teak Root Chair – Tree Root Outdoor Chair – Tree Root Garden Bench - Dining Chair",
    gambar: [f103_1,f103_2,f103_3,f103_4],
    harga: ["1320"],
    spek: ["Width: 17.7 inches | Height: 36.6 inches |Depth: 17.7 inches | Seat height: 26.7 inches | Seat width: 17.7 inches | Seat depth: 15.7 inches"],
    slug: 'wood-furniture'
   },
   {
    id: "104",
    tipe: "Console and Bar Table",
    nama: "Silver - Tree Root Console Table - Teak Root Console Table – Live Edge Table – Living Room Table",
    gambar: [f104_1,f104_2,f104_3,f104_4,f104_5,f104_6],
    harga: ["1450","1550","1750","1950","2150",],
    spek: ["Height: 31.4 inches | Diameter: 39.3 inches","Height: 31.4 inches | Diameter: 47.2 inches","Height: 31.4 inches | Diameter: 59 inches","Height: 31.4 inches | Diameter: 70.8 inches","Height: 31.4 inches | Diameter: 78.7 inches",],
    slug: 'wood-furniture'
   },
   {
    id: "105",
    tipe: "Console and Bar Table",
    nama: "Teak Root Console Table – Hand Carved Console Table – Teak Wood Console Table – Live Edge Table",
    gambar: [f105_1,f105_2,f105_3],
    harga: ["1550"],
    spek: ["Width: 39.3 inches | Height: 31.4 inches | Depth: 17.7 inches"],
    slug: 'wood-furniture'
   },
   {
    id: '106',
    nama: "Potato",
    gambar: [potato],
    deskripsi: 'Potatoes are one type of vegetable that is much loved by people around the world. Especially in countries that have a climate suitable for growing potatoes, such as Europe, North America and Australia. Potatoes have many health benefits, such as containing carbohydrates which can provide sufficient energy for the body, contain vitamin C which is good for the immune system, and contain fiber which can help bowel movements.',
    slug: 'agriculture'
   },
   {
    id: '107',
    nama: "Shallot",
    gambar: [bawang],
    deskripsi: 'Shallots are a very important kitchen ingredient throughout the world. It is used in many types of cooking, from traditional to modern cooking, and is considered a delicious and healthy ingredient. Shallots contain lots of vitamins and minerals, such as vitamin C, manganese, and potassium. It is also rich in antioxidants which help reduce the risk of chronic diseases such as heart disease and cancer. Shallots are also used in health products such as herbal medicines and food supplements. It is available in various forms, such as dried shallots, chopped shallots, and powdered shallots. Shallots are also a popular export product and are expected to continue to attract importers in the future.',
    slug: 'agriculture'
   },
   {
    id: '108',
    nama: "Japanese Yam / Sweet Potato",
    gambar: [ubijepang],
    deskripsi: 'Japanese yam / Sweet Potato is a type of plant grown for food. This plant thrives in tropical and subtropical regions. Sweet potatoes have various varieties, such as white, yellow, red, and black varieties. This plant is fast growing and can be harvested in a short time. Sweet potatoes are rich in carbohydrates, vitamin C and minerals. In addition, sweet potatoes are also used in the food processing industry, such as flour, noodles, and chips.',
    slug: 'agriculture'
   },
   {
    id: '109',
    nama: "Carrot",
    gambar: [wortel],
    deskripsi: 'Carrot is a vegetable plant that is used as food. Carrots are one of the most popular vegetables because they taste sweet and are rich in nutrients. Carrots have a high vitamin A content, so they can help maintain eye health. In addition, carrots also contain vitamin C, potassium and fiber which are good for health. Carrots can also be used in various dishes, such as soups, salads, or processed into juices.',
    slug: 'agriculture'
   },
   {
    id: '109',
    nama: "Tomato",
    gambar: [tomat],
    deskripsi: 'Tomato is a vegetable plant that is known as a food ingredient that is widely used in various dishes. Tomatoes are a rich source of vitamin C, lycopene and anti-oxidants. Lycopene contained in tomatoes can help prevent various types of cancer. Tomatoes also contain potassium, vitamin K, vitamin E, and folate which are good for health.',
    slug: 'agriculture'
   },
   {
    id: '110',
    nama: "Cassava chips",
    gambar: [chip],
    deskripsi: 'Cassava chips are chips made from grated and dried cassava tubers. It is a popular snack in several countries, especially in Asia and Latin America. Cassava chips have a crunchy and tasty texture, and can be prepared with various flavors such as salty, spicy or even chocolate.',
    slug: 'agriculture'
   },
   {
    id: '111',
    nama: "Black Plate",
    gambar: [besi1],
    deskripsi: `Iron plate is a metal plate product with a certain thickness made of carbon steel or alloy steel. Iron plate is usually used in various industrial applications such as construction, building, automotive, mining, and others.

    The quality of iron plate can be judged from various factors such as chemical composition, thickness, width, and length. Plate iron can also be found in various shapes such as round, round and square.
    
    Iron plate has several advantages such as high strength, durability, and easy cutting and manufacturing processes. These advantages make iron plate a popular choice in a variety of industries and applications.
    
    We always strive to provide quality iron plate products at competitive prices and the best service to meet customer needs. We understand the importance of iron plate products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '112',
    nama: "Bordes Plate",
    gambar: [besi2],
    deskripsi: `Iron plate is a metal plate product with a certain thickness made of carbon steel or alloy steel. Iron plate is usually used in various industrial applications such as construction, building, automotive, mining, and others.

    The quality of iron plate can be judged from various factors such as chemical composition, thickness, width, and length. Plate iron can also be found in various shapes such as round, round and square.
    
    Iron plate has several advantages such as high strength, durability, and easy cutting and manufacturing processes. These advantages make iron plate a popular choice in a variety of industries and applications.
    
    We always strive to provide quality iron plate products at competitive prices and the best service to meet customer needs. We understand the importance of iron plate products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '113',
    nama: "Galvanis Plate",
    gambar: [besi3],
    deskripsi: `Iron plate is a metal plate product with a certain thickness made of carbon steel or alloy steel. Iron plate is usually used in various industrial applications such as construction, building, automotive, mining, and others.

    The quality of iron plate can be judged from various factors such as chemical composition, thickness, width, and length. Plate iron can also be found in various shapes such as round, round and square.
    
    Iron plate has several advantages such as high strength, durability, and easy cutting and manufacturing processes. These advantages make iron plate a popular choice in a variety of industries and applications.
    
    We always strive to provide quality iron plate products at competitive prices and the best service to meet customer needs. We understand the importance of iron plate products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '114',
    nama: "Angle Steel",
    gambar: [besi4],
    deskripsi: `Angle iron is an L-shaped metal product with two oblique and two parallel sides. Angle iron is usually made of carbon steel and alloy steel, and is used in a variety of construction and industrial applications such as making building frames, making furniture, and others.

    Angle iron has several advantages such as high strength, durability, and easy cutting and manufacturing processes. These advantages make angle iron a popular choice in a variety of industries and applications.
    
    We always try to provide quality angle iron products at competitive prices and the best service to meet customer needs. We understand the importance of angle iron products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '115',
    nama: "Strep Plat",
    gambar: [besi5],
    deskripsi: `Strep iron is a metal product in the form of a rectangular profile with two parallel sides that are the same size. Strep iron is usually made of carbon steel and alloy steel, and is used in a variety of construction and industrial applications such as roof trusses, steel structure fabrication, and others.

    Strep iron has several advantages such as high strength, durability, and easy cutting and manufacturing processes. These advantages make Strep iron a popular choice in a wide variety of industries and applications.
    
    We always try to provide quality Strep iron products at competitive prices and the best service to meet customer needs. We understand the importance of Strep iron products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '116',
    nama: "Channel Steel",
    gambar: [besi6],
    deskripsi: `Channel iron is a U and C shaped metal product used in a variety of construction and industrial applications. Channel iron is made of carbon steel and alloy steel, and has two parallel sides and two slanted sides which function as a binder between the construction elements.

    Channel iron has high strength and stability, and is easy to cut, shape, and install. These advantages make channel iron a popular choice in the manufacture of building frames, furniture manufacturing, and others.
    
    We always strive to provide quality channel iron products at competitive prices and the best service to meet customer needs. We understand the importance of channel iron products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '117',
    nama: "As Steel",
    gambar: [besi7],
    deskripsi: `Ace iron is a steel product that is found with a distinctive size and shape and is usually used for a variety of construction and industrial applications. Axle iron has a number of advantages, such as good strength and stability, ability to carry large loads, and resistance to corrosion. In addition, axle iron is easy to machine and cut, and is acceptable in a variety of finishes and corrosion resistance. Steel axle products are available in various sizes and shapes, and can be selected according to the needs and specifications of the project. We always strive to provide quality channel iron products at competitive prices and the best service to meet customer needs. We understand the importance of channel iron products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '118',
    nama: "NAKO Steel",
    gambar: [besi8],
    deskripsi: `Nako iron is a type of steel profile that has an "n" or "c" shape. Nako iron products are often used as materials for steel framing for various construction and industrial projects, such as buildings, bridges, roofs, and others. Nako iron has good strength and stability, and can carry heavy loads.

    Nako iron is also acceptable in various types of corrosion resistance and has long-lasting capabilities. Nako iron products are available in various sizes and thicknesses that can be selected according to the needs and specifications of the project. In the production process, Nako iron is usually produced through a process of cutting and forming hot steel using sophisticated rolling machines.`,
    slug: 'steel'
   },
   {
    id: '119',
    nama: "Black Square Pipe Iron",
    gambar: [besi9],
    deskripsi: `Black Square Iron Pipe is a type of pipe made of black iron and has a square shape. This product is usually used in various construction and industrial projects such as building frames, pillars, table and chair frames, railings, etc. The advantages of Black Square Pipe iron include having high resistance to impact and load, having a smooth and even finish, and being available in various sizes and specifications. We always strive to provide quality channel iron products at competitive prices and the best service to meet customer needs. We understand the importance of channel iron products for our customers' business continuity and strive to provide the most effective and efficient solutions. `,
    slug: 'steel'
   },
   {
    id: '120',
    nama: "Galvanized Square Pipe Iron",
    gambar: [besi10],
    deskripsi: `Galvanized Square Pipe is a square-shaped iron product that goes through a galvanization process. This process involves adding a layer of zinc to the surface of the iron to protect it from corrosion and environmental damage. Galvanized Square Pipe is commonly used in construction applications such as making roof trusses, stairs and other constructions. The advantage of this iron is that it is resistant to corrosion and harmful environments, and has a good aesthetic appearance. We always strive to provide quality channel iron products at competitive prices and the best service to meet customer needs. We understand the importance of channel iron products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '121',
    nama: "Galvanized Steel Water Pipe",
    gambar: [besi11],
    deskripsi: `Galvanized Steel Water Pipe is one type of quality pipe that is used as a channel for clean water. This pipe is made using steel as the basic material and coated with a layer of zinc through the galvanization process. This process makes the pipes resistant to corrosion and ensures that the quality of the water that is conveyed is not affected by contamination from steel. This pipe also has a good level of strength and durability, so it can be used for various applications such as clean water distribution systems and irrigation. In addition, this pipe is also easy to install and repair and has an affordable price. We always strive to provide quality channel iron products at competitive prices and the best service to meet customer needs. We understand the importance of channel iron products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '122',
    nama: "Gas Pipe Steel",
    gambar: [besi12],
    deskripsi: `Galvanized Steel Gas Pipe is an iron pipe product which is coated with a galvanized coating to protect against corrosion. This pipe is used as a gas line and is manufactured to specifications according to industry standards. The advantage of using galvanized iron pipes is that they have good resistance to corrosion and a longer service life compared to ordinary iron pipes. This pipe also has good strength and stability making it suitable for gas line installation applications on a large scale. We always strive to provide quality channel iron products at competitive prices and the best service to meet customer needs. We understand the importance of channel iron products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '123',
    nama: 'Steel Bar',
    gambar: [besi19],
    deskripsi: `Threaded iron is a type of iron that has a threaded or curved surface like a screw. This gives iron threads additional resistance to tensile and compressive forces, so they can be used for a variety of building and industrial applications. Deformed iron is usually made by heating iron and forming it into threads, or by cutting iron into threaded pieces and placing them together to form a profile. These products can be found in various sizes and specifications, and are widely used as pipe holders, steel framing materials, and other construction materials.`,
    slug: 'steel'
   },
   {
    id: '124',
    nama: "Wide Flange - H Beam",
    gambar: [besi13],
    deskripsi: `Wide flange steel is a type of iron profile that has a shape like the letter H. This iron has a wide flange width and has a smaller web width. WF iron is used in construction applications such as the manufacture of warehouses, industrial buildings, bridges, and others. The advantages of WF iron are that it has good strength and stability and can carry heavy loads. This WF iron is also easy to cut and connect. The quality of this WF iron is ensured by rigorous testing and industry standards before it is marketed. We always strive to provide quality channel iron products at competitive prices and the best service to meet customer needs. We understand the importance of channel iron products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '125',
    nama: "Wide Flange - INP",
    gambar: [besi14],
    deskripsi: `Wide flange steel is a type of iron profile that has a shape like the letter H. This iron has a wide flange width and has a smaller web width. WF iron is used in construction applications such as the manufacture of warehouses, industrial buildings, bridges, and others. The advantages of WF iron are that it has good strength and stability and can carry heavy loads. This WF iron is also easy to cut and connect. The quality of this WF iron is ensured by rigorous testing and industry standards before it is marketed. We always strive to provide quality channel iron products at competitive prices and the best service to meet customer needs. We understand the importance of channel iron products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '127',
    nama: "Wide Flange - IWF",
    gambar: [besi15],
    deskripsi: `Wide flange steel is a type of iron profile that has a shape like the letter H. This iron has a wide flange width and has a smaller web width. WF iron is used in construction applications such as the manufacture of warehouses, industrial buildings, bridges, and others. The advantages of WF iron are that it has good strength and stability and can carry heavy loads. This WF iron is also easy to cut and connect. The quality of this WF iron is ensured by rigorous testing and industry standards before it is marketed. We always strive to provide quality channel iron products at competitive prices and the best service to meet customer needs. We understand the importance of channel iron products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '128',
    nama: "Wiremesh steel",
    gambar: [besi16],
    deskripsi: `Wire mesh is one of the iron products made of steel or iron which is processed and placed like a net. Wire mesh has many applications, ranging from use as a barrier material, security, barrier, to support. Wire mesh can be found in various shapes, sizes, and designs, according to the needs of the application. Wire mesh is very well used for construction projects and product manufacturing, such as stair railings, window doors, railings, etc. The advantages of wire mesh are corrosion resistance, durability, and easy installation. We always strive to provide quality channel iron products at competitive prices and the best service to meet customer needs. We understand the importance of channel iron products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '129',
    nama: "Welding Wire",
    gambar: [besi18],
    deskripsi: `Welding wire is a metal material used in the process of joining metals by welding. Iron welding wire is a type of welding wire made of iron and is used to perform iron welding. Usually, iron welding wire has a small diameter and can be found in several specifications, such as specifications for tensile stress and tensile strength. Its ability to withstand loads and resistance to corrosion makes iron welding wire ideal for welding applications that require high strength and stability. We always strive to provide quality channel iron products at competitive prices and the best service to meet customer needs. We understand the importance of channel iron products for our customers' business continuity and strive to provide the most effective and efficient solutions.`,
    slug: 'steel'
   },
   {
    id: '130',
    nama: "Annealed Wire",
    gambar: [besi20],
    deskripsi: `Bendrat Iron Wire is a type of steel wire used as the main ingredient in the manufacture of iron products such as fences, bridges or other buildings. This wire has a round shape and has different diameters according to needs.

    Bendrat wire iron has a very good level of strength and durability, making it very suitable for use in construction applications that require high strength and stability. This wire is also resistant to corrosion, so it can be used in hazardous environments.
    
    Bendrat wire iron also has many other benefits such as easy installation, easy to cut according to the size needed, and easy to work with. Therefore, bendrat wire is very popular and widely used in various industrial and building applications.`,
    slug: 'steel'
   },
   {
    id: '131',
    nama: 'Coal',
    gambar: [coal1],
    deskripsi: `We can meet domestic coal needs originating from Kalimantan, Sulawesi to Sumatra and distribute them to consumers in all regions and foreign countries. We can meet all coal needs with specifications GAR 3200 - 8000 by land, sea and bunkers for industry with professional services. We use the payment system "L/C & CASH" which ensures transaction security for customers.

    We always try to provide the best service and maintain the quality of the products we sell to meet customer needs. We really value customer satisfaction and try to meet all their needs in terms of coal. We understand the importance of coal for various industries and strive to provide the most effective and efficient solutions.`,
    slug: 'mining-oil-and-gas'
   },
   {
    id: '132',
    nama: 'Shisha Coconut Briquette Cube',
    gambar: [briket1],
    deskripsi: "Arguably the most common type of shisha coal. Cubes offer a slow burn and can be successfully used with most hookah bowl and screen setups due to the many different sizes available. Make sure to rotate the cubes throughout the session to get the best results.Smokeless, Odorless, No Chemical, Eco Friendly, Efficient, Burning time up to 2 Hours",
    slug: 'briquette'
   },
   {
    id: '133',
    nama: 'Barbeque Coconut Briquette Hexagon',
    gambar: [briket2],
    deskripsi: "Sawdust Charcoal is made by burning wood in the absence of oxygen. Our modern carbonization process produces strong and high density charcoal. Its unique hexagonal shape provides efficient storage, wide surface area, and easy stacking of charcoal during usage. Smokeless, Odorless, No Chemical, Eco Friendly, Efficient, Burning time up to 7 Hours",
    slug: 'briquette'
   },
   {
    id: '134',
    nama: 'B20',
    gambar: [diesel1],
    deskripsi: `Biodiesel B20 is a mixture of biodiesel and diesel fuel. The biodiesel component in B20 usually comes from renewable sources such as vegetable oils (such as palm, corn and beeswax), while the diesel oil component comes from fossil sources.

    Biodiesel B20 has several advantages compared to ordinary diesel fuel, such as having lower emissions and producing less CO2. The use of B20 biodiesel can also help reduce dependence on fossil fuels and help improve air quality.
    
    Use of B20 biodiesel requires a compatible vehicle, and usually requires no changes to the engine or fuel system. In some cases, B20 biodiesel can improve fuel efficiency and extend engine life.`,
    slug: 'mining-oil-and-gas'
   },
   {
    id: '135',
    nama: 'B30',
    gambar: [diesel2],
    deskripsi: `Biodiesel B30 is a mixture of biodiesel and diesel fuel, with a higher biodiesel content than B20. Biodiesel B30 usually consists of about 30% biodiesel and 70% diesel oil.

    Biodiesel B30 has several advantages such as having lower emissions and producing less CO2. The use of B30 biodiesel can also help reduce dependence on fossil fuels and help improve air quality.
    
    Use of B30 biodiesel requires a compatible vehicle, and usually requires no changes to the engine or fuel system. In some cases, B30 biodiesel can improve fuel efficiency and extend engine life.`,
    slug: 'mining-oil-and-gas'
   },
   {
    id: '136',
    nama: 'B100',
    gambar: [diesel3],
    deskripsi: `Biodiesel B100 is a biofuel consisting of 100% fatty acid methyl esters (FAME) and does not contain fossil fuels. Biodiesel B100 can be obtained through the esterification/transesterification process from vegetable oils such as palm, corn and canola oils, or animal fats such as beef tallow.
    Biodiesel B100 has several advantages, such as having lower emissions than fossil fuels and producing less CO2. The use of B100 biodiesel can also help reduce dependence on fossil fuels and help improve air quality.`,
    slug: 'mining-oil-and-gas'
   },
   {
    id: '137',
    nama: 'Cavendish Banana',
    deskripsi: "Cavendish bananas are a very popular type of banana all over the world. It is one of several types of bananas that are commonly found in grocery stores and are mass-produced for the export market. Cavendish bananas have soft skin and sweet, tender flesh. It's often used in smoothies, fried bananas, and a key ingredient in some cakes and pastries.",
    gambar: [pisang],
    slug: 'argiculture'
   },
   {
    id: '138',
    nama: 'Pineapple',
    deskripsi: "Pineapple is a fleshy fruit that comes from a plant called Ananas comosus. This fruit has a sweet and sour taste, often used in cooking or consumed as a snack. Pineapple has many health benefits, such as containing the enzyme bromelain which helps break down protein, contains fiber and vitamin C which are good for the digestive tract, and helps reduce the risk of certain diseases.",
    gambar: [nanas],
    slug: 'argiculture'
   },
   {
    id: '139',
    nama: 'White Pepper',
    deskripsi: "White pepper, or white peppercorns, has a wide range of uses in culinary, medicinal, and cosmetic fields. In the culinary field, white pepper is often used as a seasoning in cooking, especially in dishes based on meat, fish, chicken, and vegetables. White pepper is also often used in the manufacture of sauces, soups and other spices. In the field of medicine, white pepper is known to have anti-inflammatory and analgesic properties that can help relieve inflammation and pain. White pepper is also known to help boost the digestive system and stimulate the production of digestive enzymes, as well as help fight infections and prevent bacterial growth. In the field of cosmetics, white pepper is often used as an additive to skin and hair care products, as its antioxidant and antiseptic content can help treat and protect the skin and hair from damage. In addition, white pepper is also known as a traditional medicinal ingredient that can help with health problems such as flu, headaches, and colds.",
    gambar: [rempah1],
    slug: 'herbs-and-spices'
   },
   {
    id: '140',
    nama: 'Turmetric',
    deskripsi: "Turmeric is a natural ingredient that is often used as a spice in cooking and traditional medicine ingredients. In the culinary field, turmeric is often used as an additive to dishes based on meat, chicken, fish, vegetables, and rice. Turmeric is also often used as a natural coloring agent in foods, such as yellow rice and traditional pastries. In the field of medicine, turmeric is known to have anti-inflammatory and antioxidant properties that can help relieve inflammation, prevent the growth of cancer cells, and strengthen the immune system. In addition, turmeric is also known to help with health problems such as arthritis, high cholesterol, digestive problems, and respiratory disorders. Some studies even show that turmeric can help improve brain function and improve mental health. In traditional Indian medicine, turmeric is also used as a medicinal ingredient to treat health problems such as diabetes, allergies, asthma, and wounds. ",
    gambar: [rempah2],
    slug: 'herbs-and-spices'
   },
   {
    id: '141',
    nama: 'Cardamom',
    deskripsi: "Cardamom is a spice that is widely used in culinary, medicine, and cosmetic fields. In the culinary field, cardamom is often used as an additive to dishes based on meat, chicken, fish, vegetables, and traditional pastries. Cardamom is also often used as a base in beverages such as tea, coffee, and chocolate. In the field of medicine, cardamom is known to have antimicrobial and anti-inflammatory properties that can help fight infections and relieve inflammation. Cardamom is also known to help improve digestive function and relieve digestive problems such as nausea, vomiting, and stomach disorders. In addition, cardamom can also help relieve stress and improve mental health. In folk medicine, cardamom is also used as a remedy to treat health problems such as headaches, toothaches, and fever. In the field of cosmetics, cardamom is often used as an additive to skin and hair care products, as its antioxidant and antiseptic content can help protect the skin and hair from damage.",
    gambar: [rempah3],
    slug: 'herbs-and-spices'
   },
   {
    id: '142',
    nama: 'Coriander',
    deskripsi: "Coriander is a kitchen spice that not only gives a distinctive flavor to dishes, but also has health benefits such as helping to relieve digestive problems, having anti-inflammatory and antioxidant properties, helping to improve sleep quality, and can help lower blood sugar levels in diabetics. Thus, coriander can be a natural ingredient beneficial to the health of the human body.",
    gambar: [rempah4],
    slug: 'herbs-and-spices'
   },
   {
    id: '143',
    nama: 'Nutmeg',
    deskripsi: "Nutmeg is a spice that is often used as an additive in various types of dishes, especially in pastry dishes. In addition to providing a distinctive aroma and taste to dishes, nutmeg also has health benefits. Some of the health benefits associated with nutmeg consumption include helping to reduce the risk of developing cardiovascular diseases, boosting the immune system, overcoming digestive disorders such as diarrhea and nausea, and can help improve sleep quality. In addition, nutmeg is also known to contain antioxidant compounds that play a role in protecting body cells from damage due to free radicals. Thus, the use of nutmeg in cooking can not only provide good taste, but can also provide health benefits for the body.",
    gambar: [rempah5],
    slug: 'herbs-and-spices'
   },
   {
    id: '144',
    nama: 'Black Pepper',
    deskripsi: "Pepper or Black Pepper is one of the types of spices that are often used in cooking and traditional medicine. This spice contains active compounds such as piperine, alkaloids, and flavonoids that provide anti-inflammatory, analgesic, and antioxidant effects on the body. The use of pepper in traditional medicine aims to overcome various types of health disorders such as abdominal pain, fever, and flu. In addition, pepper is also often used as an additional ingredient in cooking because it gives a distinctive taste and enhances the taste of food. Pepper can be a good option for adding nutrients and health benefits to foods and drinks consumed daily.",
    gambar: [rempah6],
    slug: 'herbs-and-spices'
   },
   {
    id: '145',
    nama: 'Cinnamon',
    deskripsi: "Cinnamon is a type of spice that is often used as an additive in cooking, cakes, drinks, and traditional medicine. Cinnamon contains active compounds such as coumarin, cinnamaldehyde, and eugenol which have antioxidant, anti-inflammatory, and antimicrobial properties. Some of the health benefits associated with cinnamon consumption include helping to regulate blood sugar levels in diabetics, increasing good cholesterol, reducing the risk of heart disease, and can help overcome digestive problems and respiratory infections. With its distinctive taste and health benefits, cinnamon can be a good option as an additive in different types of foods and drinks.",
    gambar: [rempah7],
    slug: 'herbs-and-spices'
   },
   {
    id: '146',
    nama: 'Ginger',
    deskripsi: "Ginger is a spice that is often used in various cuisines and beverages, as well as used as an ingredient in traditional medicine in many countries. Ginger has very diverse health benefits, among which it helps relieve nausea and vomiting in pregnant women, helps with digestive problems, improves blood circulation, and has anti-inflammatory and antioxidant properties that can help protect the body from free radical damage",
    gambar: [rempah8],
    slug: 'herbs-and-spices'
   },
   {
    id: '147',
    nama: 'Galangal',
    deskripsi: "Galangal or Alpinia galanga is a type of spice that is often used in traditional cooking and medicine. This spice contains active compounds such as flavonoids, essential oils, and gingerol that provide anti-inflammatory, analgesic, and antioxidant effects on the body. The use of galangal in traditional medicine aims to overcome various types of health disorders such as headaches, abdominal pain, indigestion, and respiratory infections. In addition, galangal is also often used as an additive in cooking because it gives a fragrant aroma and a distinctive taste to food. Galangal can be a good option for adding nutrients and health benefits to foods and drinks consumed daily.",
    gambar: [rempah9],
    slug: 'herbs-and-spices'
   },
   {
    id: '148',
    nama: 'Cloves',
    deskripsi: "Cloves are the dried flowers of the clove tree, and have many uses in various fields, including medicine, culinary, and cosmetics. In the field of medicine, cloves are known to have analgesic properties that can help relieve toothache and headaches, as well as antiseptic properties that can help fight infections and prevent the development of bacteria. Cloves are also known to help boost the immune system, as well as help improve digestion and overcome stomach problems such as bloating and nausea. In the culinary field, cloves are often used as a seasoning in cooking, especially in meat-based dishes, spices, and drinks such as tea. In the field of cosmetics, cloves are often used as an additive to skin and hair care products, as their antiseptic and antioxidant content can help treat and protect the skin and hair from damage. Finally, cloves are also often used in the perfume industry, due to their distinctive and refreshing aroma.",
    gambar: [rempah10],
    slug: 'herbs-and-spices'
   },
   {
    id: '149',
    nama: 'Cumin',
    deskripsi: "Cumin is a spice commonly used in traditional medicine and cuisine. This spice contains active compounds such as cuminaldehyde, terpenes, and flavonoids that provide anti-inflammatory, antimicrobial, and antidiabetic effects on the body. The use of cumin in traditional medicine aims to overcome various types of health disorders such as abdominal pain, digestive problems, and respiratory problems. In addition, cumin is also often used as an additive in cooking because it gives food a distinctive taste and fragrant aroma. Cumin is commonly used as an additional seasoning in various types of dishes such as curries, stir-fries, and sauces. Cumin is also often used in the manufacture of breads, cakes, and beverages such as tea and coffee. Cumin can be a good option for adding nutrients and health benefits to foods and drinks consumed daily.",
    gambar: [rempah11],
    slug: 'herbs-and-spices'
   },
   {
    id: '150',
    nama: 'Vanilla',
    deskripsi: "Vanilla is a food ingredient often used in cooking and pastries to give it a distinctive aroma and taste. In addition, vanilla also has several health benefits, such as containing antioxidants that help protect body cells from damage due to free radicals, improving heart health by lowering cholesterol and triglycerides in the blood, and having anti-inflammatory properties that can help reduce inflammation in the body. In addition, vanilla is also used in the cosmetic and pharmaceutical industries to give aroma and flavor to their products. Thus, vanilla has many uses in various fields and is essential for improving the taste and aroma qualities of food as well as providing health benefits for the body.",
    gambar: [rempah12],
    slug: 'herbs-and-spices'
   },
   {
    id: '151',
    nama: 'Euro 5',
    deskripsi: "Euro-5 In an effort to reduce emissions, the European Union (EU) is taking a step towards using more environmentally friendly transportation technologies. In the early 1990s the EU issued regulations mandating the use of catalysts for gasoline cars, often called the Euro 1 standard. This aims to reduce the level of pollutants produced by motor vehicles. Then gradually the EU tightened the regulations to the Euro 2 (1996), Euro 3 (2000), Euro 4 (2005), Euro5 (2009), and Euro 6 (2014) standards.",
    gambar: [diesel4],
    slug: 'mining-oil-and-gas'
   },
   


   
  
];


export const people = [
  {
    nama: 'YUDY HADI WIBOWO',
    gambar: yudy,
    jabatan: 'President Director',
    quotes: "Integrity is an indicator of one's success and trust is built with good communication.",
    links: [
      {
        nama: 'linkedin',
        icon: linkedin,
        url: 'https://www.linkedin.com/in/yudyhadiwibowo/'
      },
      {
        nama: 'instagram',
        icon: instagram,
        url: 'http://www.instagram.com/yudyhadi'
      },
    ]
  },
  {
    nama: 'MUHAMMAD RAFLI RAMADHAN',
    gambar: rafli,
    jabatan: 'Director of Information Technology',
    quotes: "The more I read, the more I acquire, the more certain I am that I know nothing.",
    links: [
      {
        nama: 'linkedin',
        icon: linkedin,
        url: 'https://www.linkedin.com/in/raflidev/'
      },
      {
        nama: 'instagram',
        icon: instagram,
        url: 'http://www.instagram.com/raflidev'
      },
    ]
  },
  {
    nama: 'Muhammad Rizal Affandi',
    gambar: affandi,
    jabatan: 'Finance Director',
    quotes: "The more I read, the more I acquire, the more certain I am that I know nothing.",
    links: [
      {
        nama: 'linkedin',
        icon: linkedin,
        url: 'https://www.linkedin.com/in/raflidev/'
      },
      {
        nama: 'instagram',
        icon: instagram,
        url: 'http://www.instagram.com/raflidev'
      },
    ]
  },
  {
    nama: 'Jordan Nathanael Makeen Kamasi',
    gambar: jordan,
    jabatan: 'Director of Operations and Risk Management',
    quotes: "The more I read, the more I acquire, the more certain I am that I know nothing.",
    links: [
      {
        nama: 'linkedin',
        icon: linkedin,
        url: 'https://www.linkedin.com/in/raflidev/'
      },
      {
        nama: 'instagram',
        icon: instagram,
        url: 'http://www.instagram.com/raflidev'
      },
    ]
  },
  {
    nama: 'Nikodemus Rivaldo Rindorindo',
    gambar: rivaldo,
    jabatan: 'Marketing Director',
    quotes: "The more I read, the more I acquire, the more certain I am that I know nothing.",
    links: [
      {
        nama: 'linkedin',
        icon: linkedin,
        url: 'https://www.linkedin.com/in/raflidev/'
      },
      {
        nama: 'instagram',
        icon: instagram,
        url: 'http://www.instagram.com/raflidev'
      },
    ]
  },
  // {
  //   nama: 'MUHAMMAD RIZKY AZRA',
  //   gambar: azra,
  //   jabatan: 'Head of Finance',
  //   quotes: "The secret of happiness live in 3 things: patience, gratitude, and sincerity",
  //   links: [
  //     {
  //       nama: 'instagram',
  //       icon: instagram, 
  //       url: 'https://www.instagram.com/Muhammadazra/'
  //     },
  //   ]
  // },
  // {
  //   nama: 'Hafizt Ghilman Ramadhan Ladupa',
  //   gambar: ghilman,
  //   jabatan: 'Head of Operational',
  //   quotes: "The only way to do great work is to love what you do. If you haven’t found it yet, keep looking. Don’t settle.",
  //   links: [
  //     {
  //       nama: 'instagram',
  //       icon: instagram,
  //       url: 'https://www.instagram.com//hafiztghilman/'
  //     },
  //   ]
  // },
  
];
